"use strict";
var MilouAnalytics = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // packages/tracker/src/index.ts
  var index_exports = {};
  __export(index_exports, {
    experimentVariantViewed: () => experimentVariantViewed,
    flush: () => flush,
    initTracker: () => initTracker,
    queueEvent: () => queueEvent,
    track: () => track
  });

  // packages/shared/src/index.ts
  var COMMERCE_SCHEMA_VERSION = 2;
  var COMMERCE_EVENTS_V2 = {
    PAGE_VIEW: "page_view",
    PAGE_ENGAGEMENT: "page_engagement",
    PRODUCT_VIEW: "product_view",
    COLLECTION_VIEW: "collection_view",
    SEARCH_PERFORMED: "search_performed",
    PRODUCT_RECOMMENDATION_STARTED: "product_recommendation_started",
    PRODUCT_RECOMMENDATION_STEP_COMPLETED: "product_recommendation_step_completed",
    PRODUCT_RECOMMENDATION_COMPLETED: "product_recommendation_completed",
    VARIANT_SELECTED: "variant_selected",
    BUNDLE_CONFIGURED: "bundle_configured",
    SUBSCRIPTION_SELECTED: "subscription_selected",
    ADD_TO_CART: "add_to_cart",
    ADD_TO_CART_FAILED: "add_to_cart_failed",
    REMOVE_FROM_CART: "remove_from_cart",
    CART_VIEW: "cart_view",
    CHECKOUT_INTENT_SUBMITTED: "checkout_intent_submitted",
    CHECKOUT_STARTED: "checkout_started",
    CHECKOUT_CONTACT_SUBMITTED: "checkout_contact_submitted",
    CHECKOUT_ADDRESS_SUBMITTED: "checkout_address_submitted",
    CHECKOUT_SHIPPING_SUBMITTED: "checkout_shipping_submitted",
    CHECKOUT_PAYMENT_SUBMITTED: "checkout_payment_submitted",
    CHECKOUT_COMPLETED: "checkout_completed",
    PURCHASE_CONFIRMED: "purchase_confirmed",
    ORDER_CANCELLED: "order_cancelled",
    ORDER_REFUNDED: "order_refunded",
    NEWSLETTER_SIGNUP_SUBMITTED: "newsletter_signup_submitted",
    NEWSLETTER_SIGNUP_ACCEPTED: "newsletter_signup_accepted",
    NEWSLETTER_SIGNUP_FAILED: "newsletter_signup_failed",
    NEWSLETTER_SUBSCRIPTION_CONFIRMED: "newsletter_subscription_confirmed",
    NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBED: "newsletter_subscription_unsubscribed",
    WAITLIST_SIGNUP_SUBMITTED: "waitlist_signup_submitted",
    BACK_IN_STOCK_REQUESTED: "back_in_stock_requested",
    CONSENT_BANNER_VIEWED: "consent_banner_viewed",
    CONSENT_CHOICE_SAVED: "consent_choice_saved",
    CONSENT_CHOICE_RESET: "consent_choice_reset",
    WELCOME_POPUP_VIEWED: "welcome_popup_viewed",
    WELCOME_POPUP_CLOSED: "welcome_popup_closed",
    PRODUCT_BUYBOX_VIEWED: "product_buybox_viewed",
    PRODUCT_CTA_VIEWED: "product_cta_viewed",
    PRODUCT_CTA_CLICKED: "product_cta_clicked",
    PRODUCT_TRUST_MODULE_VIEWED: "product_trust_module_viewed",
    PRODUCT_TRUST_ITEM_CLICKED: "product_trust_item_clicked",
    PRODUCT_REVIEW_SUMMARY_CLICKED: "product_review_summary_clicked",
    PRODUCT_REVIEW_SECTION_VIEWED: "product_review_section_viewed",
    PRODUCT_GALLERY_NAVIGATED: "product_gallery_navigated",
    DOG_SIZE_SELECTED: "dog_size_selected",
    PRODUCT_DETAIL_TOGGLED: "product_detail_toggled",
    EXPERIMENT_VARIANT_VIEWED: "experiment_variant_viewed",
    WEB_VITAL: "web_vital",
    USER_FACING_ERROR: "user_facing_error",
    OUTBOUND_CLICK: "outbound_click"
  };
  var MILOU_ANALYTICS_LEGACY_ALIASES = {
    checkout_click: COMMERCE_EVENTS_V2.CHECKOUT_INTENT_SUBMITTED,
    quiz_start: COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_STARTED,
    quiz_step: COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_STEP_COMPLETED,
    quiz_complete: COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_COMPLETED,
    confirmed: COMMERCE_EVENTS_V2.NEWSLETTER_SUBSCRIPTION_CONFIRMED,
    unsubscribed: COMMERCE_EVENTS_V2.NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBED
  };
  function eventBuilder(eventName) {
    return (context2, properties, compatibility2 = {}) => ({
      ...context2,
      ...compatibility2,
      schema_version: COMMERCE_SCHEMA_VERSION,
      event_name: eventName,
      properties,
      event_type: eventName,
      event_ts: context2.occurred_at,
      page_visit_id: context2.page_view_id,
      event_data: properties
    });
  }
  var createPageViewEvent = eventBuilder(COMMERCE_EVENTS_V2.PAGE_VIEW);
  var createPageEngagementEvent = eventBuilder(COMMERCE_EVENTS_V2.PAGE_ENGAGEMENT);
  var createProductViewEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_VIEW);
  var createCollectionViewEvent = eventBuilder(COMMERCE_EVENTS_V2.COLLECTION_VIEW);
  var createSearchPerformedEvent = eventBuilder(COMMERCE_EVENTS_V2.SEARCH_PERFORMED);
  var createProductRecommendationStartedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_STARTED);
  var createProductRecommendationStepCompletedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_STEP_COMPLETED);
  var createProductRecommendationCompletedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_RECOMMENDATION_COMPLETED);
  var createVariantSelectedEvent = eventBuilder(COMMERCE_EVENTS_V2.VARIANT_SELECTED);
  var createBundleConfiguredEvent = eventBuilder(COMMERCE_EVENTS_V2.BUNDLE_CONFIGURED);
  var createSubscriptionSelectedEvent = eventBuilder(COMMERCE_EVENTS_V2.SUBSCRIPTION_SELECTED);
  var createAddToCartEvent = eventBuilder(COMMERCE_EVENTS_V2.ADD_TO_CART);
  var createAddToCartFailedEvent = eventBuilder(COMMERCE_EVENTS_V2.ADD_TO_CART_FAILED);
  var createRemoveFromCartEvent = eventBuilder(COMMERCE_EVENTS_V2.REMOVE_FROM_CART);
  var createCartViewEvent = eventBuilder(COMMERCE_EVENTS_V2.CART_VIEW);
  var createCheckoutIntentSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_INTENT_SUBMITTED);
  var createCheckoutStartedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_STARTED);
  var createCheckoutContactSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_CONTACT_SUBMITTED);
  var createCheckoutAddressSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_ADDRESS_SUBMITTED);
  var createCheckoutShippingSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_SHIPPING_SUBMITTED);
  var createCheckoutPaymentSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_PAYMENT_SUBMITTED);
  var createCheckoutCompletedEvent = eventBuilder(COMMERCE_EVENTS_V2.CHECKOUT_COMPLETED);
  var createPurchaseConfirmedEvent = eventBuilder(COMMERCE_EVENTS_V2.PURCHASE_CONFIRMED);
  var createOrderCancelledEvent = eventBuilder(COMMERCE_EVENTS_V2.ORDER_CANCELLED);
  var createOrderRefundedEvent = eventBuilder(COMMERCE_EVENTS_V2.ORDER_REFUNDED);
  var createNewsletterSignupSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.NEWSLETTER_SIGNUP_SUBMITTED);
  var createNewsletterSignupAcceptedEvent = eventBuilder(COMMERCE_EVENTS_V2.NEWSLETTER_SIGNUP_ACCEPTED);
  var createNewsletterSignupFailedEvent = eventBuilder(COMMERCE_EVENTS_V2.NEWSLETTER_SIGNUP_FAILED);
  var createNewsletterSubscriptionConfirmedEvent = eventBuilder(COMMERCE_EVENTS_V2.NEWSLETTER_SUBSCRIPTION_CONFIRMED);
  var createNewsletterSubscriptionUnsubscribedEvent = eventBuilder(COMMERCE_EVENTS_V2.NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBED);
  var createWaitlistSignupSubmittedEvent = eventBuilder(COMMERCE_EVENTS_V2.WAITLIST_SIGNUP_SUBMITTED);
  var createBackInStockRequestedEvent = eventBuilder(COMMERCE_EVENTS_V2.BACK_IN_STOCK_REQUESTED);
  var createConsentBannerViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.CONSENT_BANNER_VIEWED);
  var createConsentChoiceSavedEvent = eventBuilder(COMMERCE_EVENTS_V2.CONSENT_CHOICE_SAVED);
  var createConsentChoiceResetEvent = eventBuilder(COMMERCE_EVENTS_V2.CONSENT_CHOICE_RESET);
  var createWelcomePopupViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.WELCOME_POPUP_VIEWED);
  var createWelcomePopupClosedEvent = eventBuilder(COMMERCE_EVENTS_V2.WELCOME_POPUP_CLOSED);
  var createProductBuyboxViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_BUYBOX_VIEWED);
  var createProductCtaViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_CTA_VIEWED);
  var createProductCtaClickedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_CTA_CLICKED);
  var createProductTrustModuleViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_TRUST_MODULE_VIEWED);
  var createProductTrustItemClickedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_TRUST_ITEM_CLICKED);
  var createProductReviewSummaryClickedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_REVIEW_SUMMARY_CLICKED);
  var createProductReviewSectionViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_REVIEW_SECTION_VIEWED);
  var createProductGalleryNavigatedEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_GALLERY_NAVIGATED);
  var createDogSizeSelectedEvent = eventBuilder(COMMERCE_EVENTS_V2.DOG_SIZE_SELECTED);
  var createProductDetailToggledEvent = eventBuilder(COMMERCE_EVENTS_V2.PRODUCT_DETAIL_TOGGLED);
  var createExperimentVariantViewedEvent = eventBuilder(COMMERCE_EVENTS_V2.EXPERIMENT_VARIANT_VIEWED);
  var createWebVitalEvent = eventBuilder(COMMERCE_EVENTS_V2.WEB_VITAL);
  var createUserFacingErrorEvent = eventBuilder(COMMERCE_EVENTS_V2.USER_FACING_ERROR);
  var createOutboundClickEvent = eventBuilder(COMMERCE_EVENTS_V2.OUTBOUND_CLICK);

  // packages/tracker/src/core.ts
  function replayScriptSource(value, baseUrl) {
    if (typeof value !== "string" || !value || value.length > 500) return null;
    try {
      const url = new URL(value, baseUrl);
      return url.protocol === "https:" && !url.username && !url.password ? url.href : null;
    } catch {
      return null;
    }
  }
  function engagementCheckpoint(totalMilliseconds, scroll, previousSeconds) {
    const summary = engagementSummary(totalMilliseconds, scroll);
    return { totalSeconds: summary.active_seconds, properties: { ...summary, active_seconds: Math.max(0, summary.active_seconds - previousSeconds) } };
  }
  function resolveMeasurementLanes(consent) {
    const firstParty = consent.first_party === true;
    const analytics = consent.analytics === true;
    const marketing = consent.marketing === true;
    return {
      observe: firstParty || analytics || marketing,
      first_party: firstParty,
      analytics,
      marketing,
      attribution_storage: firstParty || marketing
    };
  }
  function gaContextFromCookieString(cookieString) {
    const cookies = /* @__PURE__ */ new Map();
    for (const part of cookieString.split(";")) {
      const separator = part.indexOf("=");
      if (separator < 1) continue;
      const name = part.slice(0, separator).trim();
      let value = part.slice(separator + 1).trim();
      try {
        value = decodeURIComponent(value);
      } catch {
      }
      if (name && value) cookies.set(name, value);
    }
    const clientCookie = cookies.get("_ga") ?? "";
    const clientParts = clientCookie.split(".");
    const clientId = clientParts.length >= 4 ? `${clientParts.at(-2)}.${clientParts.at(-1)}` : void 0;
    let sessionId;
    for (const [name, value] of cookies) {
      if (!name.startsWith("_ga_") || name === "_ga") continue;
      const match = value.match(/^GS\d+\.\d+\.(?:s)?(\d{1,20})(?:[.$]|$)/);
      if (match?.[1]) {
        sessionId = match[1];
        break;
      }
    }
    return {
      ...clientId && /^\d+\.\d+$/.test(clientId) ? { client_id: clientId } : {},
      ...sessionId ? { session_id: sessionId } : {}
    };
  }
  var ATTRIBUTION_FIELDS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid"
  ];
  var SURFACES = /* @__PURE__ */ new Set([
    "storefront_page",
    "product_buybox",
    "sticky_buybox",
    "product_card",
    "quick_add",
    "cross_sell",
    "bundle_builder",
    "subscription_selector",
    "quiz",
    "quiz_result",
    "search_page",
    "predictive_search",
    "cart_drawer",
    "cart_page",
    "cart_sticky",
    "checkout",
    "footer_newsletter",
    "welcome_popup",
    "article_newsletter",
    "wissen_newsletter",
    "quiz_newsletter",
    "password_newsletter",
    "product_waitlist",
    "back_in_stock",
    "external_link",
    "unknown"
  ]);
  function normalizeSurface(value) {
    if (typeof value !== "string") return "unknown";
    return SURFACES.has(value) ? value : "unknown";
  }
  function clipped(value, max = 160) {
    const normalized = value?.trim();
    if (!normalized) return void 0;
    return normalized.slice(0, max);
  }
  function attributionTouchFromUrl(url, capturedAt, referrerHost2) {
    const touch = {
      captured_at: capturedAt,
      referrer_host: clipped(referrerHost2, 120)
    };
    for (const field of ATTRIBUTION_FIELDS) {
      const value = clipped(url.searchParams.get(field));
      if (value) touch[field] = value;
    }
    const hasCampaignValue = ATTRIBUTION_FIELDS.some((field) => Boolean(touch[field]));
    if (!hasCampaignValue && !touch.referrer_host) return void 0;
    return touch;
  }
  function isNonDirectTouch(touch) {
    if (!touch) return false;
    return ATTRIBUTION_FIELDS.some((field) => Boolean(touch[field])) || Boolean(touch.referrer_host);
  }
  function updateStoredAttribution(stored, current, now) {
    const next = {
      version: 2,
      first_touch: stored?.first_touch,
      last_non_direct: stored?.last_non_direct,
      updated_at: now
    };
    if (current && !next.first_touch) next.first_touch = current;
    if (isNonDirectTouch(current)) next.last_non_direct = current;
    return next;
  }
  function attributionSnapshot(stored, current) {
    return {
      first_touch: stored?.first_touch,
      last_non_direct: stored?.last_non_direct,
      current_touch: current
    };
  }
  function engagementSummary(activeMilliseconds2, maxScrollPercent2) {
    return {
      active_seconds: Math.max(0, Math.min(1800, Math.round(activeMilliseconds2 / 1e3))),
      max_scroll_percent: Math.max(0, Math.min(100, Math.round(maxScrollPercent2)))
    };
  }
  var VITAL_THRESHOLDS = {
    LCP: [2500, 4e3],
    INP: [200, 500],
    CLS: [0.1, 0.25],
    FCP: [1800, 3e3],
    TTFB: [800, 1800]
  };
  function webVitalRating(name, value) {
    const [good, poor] = VITAL_THRESHOLDS[name];
    if (value <= good) return "good";
    if (value <= poor) return "needs_improvement";
    return "poor";
  }
  function commerceItemFromCartLine(line) {
    const id = line.variant_id ?? line.id;
    if (id == null) return null;
    const quantity = Math.max(1, Math.round(Number(line.quantity) || 1));
    const valueMinor = Math.max(
      0,
      Math.round(
        line.line_price != null ? Number(line.line_price) : (Number(line.price) || 0) * quantity
      )
    );
    const sellingPlanId = line.selling_plan_allocation?.selling_plan?.id;
    return {
      variant_id: String(id),
      quantity,
      value_minor: valueMinor,
      product_handle: clipped(line.handle, 120),
      selling_plan_id: sellingPlanId == null ? void 0 : String(sellingPlanId)
    };
  }
  function uxCheckpointChanged(previous, activeSeconds, scroll, reachedKeys, hasPoints) {
    const signature = JSON.stringify([activeSeconds, scroll, [...reachedKeys].sort()]);
    return { signature, changed: hasPoints || signature !== previous };
  }
  function cartAddLines(response) {
    if (!response || typeof response !== "object") return [];
    const value = response;
    if (Array.isArray(value.items)) return value.items.filter((line) => Boolean(line && typeof line === "object"));
    if (value.id != null || value.variant_id != null) return [value];
    return [];
  }
  function parsedValue(input) {
    if (!input || typeof input !== "object") return {};
    const value = input;
    const id = value.id == null ? void 0 : String(value.id);
    const lineNumber = Number(value.line);
    const quantityNumber = Number(value.quantity);
    return {
      id,
      line: Number.isFinite(lineNumber) && lineNumber > 0 ? Math.round(lineNumber) : void 0,
      quantity: Number.isFinite(quantityNumber) ? Math.round(quantityNumber) : void 0
    };
  }
  function parseCartMutationBody(body) {
    if (body instanceof URLSearchParams) return parsedValue(Object.fromEntries(body.entries()));
    if (typeof FormData !== "undefined" && body instanceof FormData) return parsedValue(Object.fromEntries(body.entries()));
    if (typeof body !== "string" || !body) return {};
    try {
      return parsedValue(JSON.parse(body));
    } catch {
      return parsedValue(Object.fromEntries(new URLSearchParams(body).entries()));
    }
  }
  function findChangedCartLine(items, mutation) {
    if (!items?.length) return void 0;
    if (mutation.line != null) return items[mutation.line - 1];
    if (!mutation.id) return void 0;
    return items.find(
      (item) => String(item.key ?? "") === mutation.id || String(item.variant_id ?? "") === mutation.id || String(item.id ?? "") === mutation.id
    );
  }

  // packages/tracker/src/delivery.ts
  async function retryReplayChunk(send, allowed, pause) {
    for (let attempt = 0; attempt < 3 && allowed(); attempt++) {
      try {
        if ((await send())?.ok) return true;
      } catch {
      }
      if (attempt < 2 && allowed()) await pause(250 * 2 ** attempt);
    }
    return false;
  }
  function createOwnedDelivery(options) {
    const pending = /* @__PURE__ */ new Map();
    const running = /* @__PURE__ */ new Set();
    let timer;
    let generation = 0;
    function clear() {
      generation++;
      pending.clear();
      if (timer) options.cancel(timer);
      timer = void 0;
    }
    function later(delay) {
      if (timer) return;
      timer = options.schedule(() => {
        timer = void 0;
        void flush2();
      }, delay);
    }
    async function flush2() {
      if (!options.allowed()) {
        clear();
        return;
      }
      const epoch = generation;
      await Promise.all([...pending.entries()].filter(([id, packet]) => !running.has(id) && packet.attempts < 5).map(async ([id, packet]) => {
        running.add(id);
        packet.attempts++;
        try {
          const response = await options.fetch(packet.url, {
            method: "POST",
            credentials: "omit",
            headers: { "content-type": "text/plain;charset=UTF-8" },
            body: packet.body,
            keepalive: true,
            signal: AbortSignal.timeout(5e3)
          });
          const receipt = response.ok ? await response.json() : null;
          if (generation === epoch && pending.get(id) === packet && receipt && packet.accept(receipt)) pending.delete(id);
        } catch {
        } finally {
          running.delete(id);
        }
      }));
      if (generation !== epoch || !options.allowed()) return;
      const retryable = [...pending.values()].filter((packet) => packet.attempts < 5);
      if (retryable.length) later(Math.min(8e3, 500 * 2 ** Math.max(...retryable.map((p) => p.attempts))));
    }
    function enqueue(id, url, body, accept) {
      if (!options.allowed() || pending.has(id)) return;
      if (pending.size >= 32) {
        console.warn("[Milou analytics] delivery queue full");
        return;
      }
      pending.set(id, { url, body: JSON.stringify(body), accept, attempts: 0 });
      void flush2();
    }
    function beacon() {
      if (!options.allowed()) {
        clear();
        return;
      }
      for (const packet of pending.values()) {
        if (new TextEncoder().encode(packet.body).byteLength > 48 * 1024) continue;
        try {
          options.beacon(packet.url, new Blob([packet.body], { type: "text/plain;charset=UTF-8" }));
        } catch {
        }
      }
    }
    function resume() {
      for (const packet of pending.values()) packet.attempts = 0;
      void flush2();
    }
    return { enqueue, flush: flush2, beacon, resume, clear, get pendingCount() {
      return pending.size;
    } };
  }

  // packages/tracker/src/index.ts
  var FLUSH_MS = 1500;
  var MAX_QUEUE_SIZE = 100;
  var PRODUCT_DECISION_PROOF_VISIBILITY_MS = 1e3;
  var PRODUCT_DECISION_PROOF_VISIBILITY_RATIO = 0.5;
  var UX_FIRST_FLUSH_MS = 5e3;
  var UX_FLUSH_MS = 15e3;
  var UX_MASK_POLICY_VERSION = "mc-ux-v1";
  var REPLAY_MASK_POLICY_VERSION = "mc-replay-v1";
  var REPLAY_RECORDER_VERSION = "rrweb@2.1.1";
  var REPLAY_FLUSH_MS = 2e3;
  var REPLAY_CHUNK_TARGET_BYTES = 48 * 1024;
  var REPLAY_MAX_EVENT_BYTES = 1800 * 1024;
  var REPLAY_MAX_TRANSPORT_BYTES = 512 * 1024;
  var REPLAY_CLIENT_BYTE_LIMIT = 15 * 1024 * 1024;
  var REPLAY_MAX_CHUNKS = 200;
  var ATTRIBUTION_STORAGE_KEY = "mc_commerce_attribution_v2";
  var CART_ATTR_SYNC_KEY = "mc_commerce_cart_attr_signature_v2";
  var LEGACY_FIRST_PARTY_STORAGE_KEYS = [
    "mc_commerce_browser_v2",
    "mc_commerce_session_v2",
    "mc_commerce_cart_v2"
  ];
  var FIRST_PARTY_CART_ATTRIBUTE_KEYS = ["__mc_browser_id", "__mc_session_id", "__mc_cart_id"];
  var ANALYTICS_CART_ATTRIBUTE_KEYS = ["__mc_ga_client_id", "__mc_ga_session_id"];
  var ATTRIBUTION_CART_ATTRIBUTE_KEYS = ["first", "last", "current"].flatMap((model) => [
    ...ATTRIBUTION_FIELDS.map((field) => `__mc_attr_${model}_${field}`),
    `__mc_attr_${model}_referrer_host`,
    `__mc_attr_${model}_captured_at`
  ]);
  var flushTimer = null;
  var eventQueue = [];
  var ownedDelivery = createOwnedDelivery({
    allowed: firstPartyAllowed,
    fetch: (...args) => window.fetch(...args),
    beacon: (url, body) => navigator.sendBeacon?.(url, body) ?? false,
    schedule: (callback, delay) => setTimeout(callback, delay),
    cancel: (timer) => clearTimeout(timer)
  });
  var deliveredEventIds = /* @__PURE__ */ new Set();
  var semanticDedupe = /* @__PURE__ */ new Map();
  var listenersAttached = false;
  var fetchIntercepted = false;
  var trackingActive = false;
  var pageViewId = "";
  var pageStartAt = 0;
  var activeStartedAt = 0;
  var activeMilliseconds = 0;
  var maxScrollPercent = 0;
  var engagementRecorded = false;
  var reportedActiveSeconds = 0;
  var reportedScrollPercent = 0;
  var vitalsFinalized = false;
  var pendingCommerceAction = null;
  var currentTouch;
  var storedAttribution;
  var latestCart;
  var lastCartAttributeSignature = "";
  var productVisibilityObserver = null;
  var viewedProductCtas = /* @__PURE__ */ new WeakSet();
  var productDecisionProofObserver = null;
  var uxSectionObserver = null;
  var uxFlushTimer = null;
  var uxStartedAt = 0;
  var uxLastCheckpoint = "";
  var uxLastPointer = null;
  var uxPointCounts = /* @__PURE__ */ new Map();
  var uxSections = /* @__PURE__ */ new Map();
  var replayStop;
  var replayId = "";
  var replayUploadToken = "";
  var replayChunkIndex = 0;
  var replayByteCount = 0;
  var replayStartedAt = "";
  var replayEvents = [];
  var replayEventsBytes = 0;
  var replayFlushTimer = null;
  var replayUploadChain = Promise.resolve();
  var replayLoader = null;
  var replayReceipt = { chunks: 0, bytes: 0, endedAt: "", failed: false };
  var observedProductElements = /* @__PURE__ */ new WeakSet();
  var observedProductDetails = /* @__PURE__ */ new WeakSet();
  var observedProductDecisionProofElements = /* @__PURE__ */ new WeakSet();
  var productDecisionProofVisibility = /* @__PURE__ */ new Map();
  var productTrustModuleViewed = false;
  var productReviewSectionViewed = false;
  var pendingProductDetailToggles = /* @__PURE__ */ new WeakMap();
  var newsletterOutcomeKeys = /* @__PURE__ */ new Set();
  var vitalValues = /* @__PURE__ */ new Map();
  var vitalSent = /* @__PURE__ */ new Set();
  var runtimeDecisionId = randomValue();
  var runtimeDecidedAt = (/* @__PURE__ */ new Date()).toISOString();
  function cfg() {
    return window.MC_ANALYTICS_CONFIG ?? {};
  }
  function ecomm() {
    return window.MC_ECOMMERCE ?? {};
  }
  function randomValue() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const bytes = new Uint8Array(16);
    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
      crypto.getRandomValues(bytes);
    } else {
      for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }
    bytes[6] = bytes[6] & 15 | 64;
    bytes[8] = bytes[8] & 63 | 128;
    const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  function entityId(prefix) {
    return `${prefix}_${randomValue().replace(/-/g, "")}`;
  }
  function eventId() {
    return randomValue();
  }
  function cleanString(value, max = 160) {
    if (typeof value !== "string") return void 0;
    const normalized = value.trim();
    return normalized ? normalized.slice(0, max) : void 0;
  }
  function cleanInteger(value, fallback = 0) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.max(0, Math.round(number)) : fallback;
  }
  function cleanNullableCount(value) {
    if (value == null || typeof value === "string" && !value.trim()) return null;
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 && number <= 1e6 ? number : null;
  }
  function cleanSemanticKey(value, max = 80) {
    if (typeof value !== "string") return void 0;
    const key = value.trim();
    return key.length <= max && /^[a-z][a-z0-9_]*$/.test(key) ? key : void 0;
  }
  function readConsent() {
    try {
      const apiValue = window.mcCookieConsent?.get();
      if (apiValue) return apiValue;
      const raw = window.localStorage.getItem("mc_cookie_consent_v3");
      if (!raw) return null;
      const stored = JSON.parse(raw);
      return stored.v === 3 ? stored : null;
    } catch {
      return null;
    }
  }
  function consentSnapshot() {
    const stored = readConsent();
    const gpc = stored?.gpc === true || navigator.globalPrivacyControl === true;
    const dnt = stored?.dnt === true || navigator.doNotTrack === "1" || window.doNotTrack === "1";
    return {
      analytics: stored?.analytics === true,
      marketing: stored?.marketing === true,
      preferences: stored?.preferences === true,
      first_party: !gpc && !dnt && stored?.first_party !== false,
      sale_of_data: stored?.sale_of_data === true,
      consent_version: 3,
      decision_id: cleanString(stored?.decision_id, 80) ?? runtimeDecisionId,
      decided_at: stored?.ts ? new Date(stored.ts).toISOString() : runtimeDecidedAt,
      gpc,
      dnt
    };
  }
  function firstPartyAllowed() {
    return resolveMeasurementLanes(consentSnapshot()).first_party;
  }
  function analyticsAllowed() {
    return resolveMeasurementLanes(consentSnapshot()).analytics;
  }
  function attributionStorageAllowed() {
    return resolveMeasurementLanes(consentSnapshot()).attribution_storage;
  }
  function referrerHost() {
    if (!document.referrer) return void 0;
    try {
      const host = new URL(document.referrer).hostname.replace(/^www\./, "");
      return host === location.hostname.replace(/^www\./, "") ? void 0 : host;
    } catch {
      return void 0;
    }
  }
  function readStoredAttribution() {
    try {
      const raw = window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY);
      return raw ? JSON.parse(raw) : void 0;
    } catch {
      return void 0;
    }
  }
  function writeStoredAttribution(value) {
    try {
      window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(value));
    } catch {
    }
  }
  function captureAttribution() {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    currentTouch = attributionTouchFromUrl(new URL(location.href), now, referrerHost());
    if (!attributionStorageAllowed()) return;
    const existing = readStoredAttribution();
    storedAttribution = updateStoredAttribution(existing?.version === 2 ? existing : void 0, currentTouch, now);
    writeStoredAttribution(storedAttribution);
  }
  function getAttribution() {
    if (!storedAttribution && attributionStorageAllowed()) {
      const value = readStoredAttribution();
      if (value?.version === 2) storedAttribution = value;
    }
    return attributionSnapshot(storedAttribution, currentTouch);
  }
  function pageSurface() {
    if (cfg().pageType === "cart") return "cart_page";
    if (cfg().pageType === "search") return "search_page";
    return "storefront_page";
  }
  function viewportBucket() {
    const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (width < 390) return "mobile_narrow";
    if (width < 768) return "mobile_wide";
    if (width < 1024) return "tablet";
    if (width < 1440) return "desktop";
    return "desktop_wide";
  }
  function cleanUrlParam(name, maxLength = 160) {
    try {
      return cleanString(new URL(location.href).searchParams.get(name), maxLength);
    } catch {
      return void 0;
    }
  }
  function experienceContext() {
    const attribution = getAttribution();
    return {
      storefront_release: cleanString(cfg().storefrontRelease, 120),
      page_template_version: cleanString(cfg().pageTemplateVersion, 120),
      landing_variant: cleanUrlParam("mc_landing_variant", 120) ?? cleanString(cfg().landingVariant, 120) ?? cleanUrlParam("mc_variant", 120),
      viewport_bucket: viewportBucket(),
      orientation: window.innerWidth >= window.innerHeight ? "landscape" : "portrait",
      creative_key: cleanString(attribution.current_touch?.utm_content, 160),
      provider_campaign_id: cleanUrlParam("mc_campaign_id"),
      provider_adset_id: cleanUrlParam("mc_adset_id"),
      provider_ad_id: cleanUrlParam("mc_ad_id"),
      provider_platform: cleanUrlParam("mc_platform", 80),
      provider_placement: cleanUrlParam("mc_placement", 120),
      creative_format: cleanUrlParam("mc_creative_format", 80)
    };
  }
  function context(surface, overrides = {}) {
    return {
      event_id: eventId(),
      source: "storefront_browser",
      occurred_at: (/* @__PURE__ */ new Date()).toISOString(),
      surface,
      page_view_id: pageViewId || void 0,
      page_path: location.pathname,
      page_type: cfg().pageType ?? "unknown",
      is_internal: cfg().isInternal === true,
      is_verified_bot: false,
      consent: consentSnapshot(),
      attribution: getAttribution(),
      experience_context: experienceContext(),
      ...overrides
    };
  }
  function compatibility() {
    return { shop_domain: cleanString(cfg().shopDomain, 160) };
  }
  function collectUrl() {
    const url = (cfg().ingressUrl ?? "").replace(/\/$/, "");
    return url ? `${url}/analytics/v1/collect` : "";
  }
  function observabilityUrl(path) {
    const url = (cfg().ingressUrl ?? "").replace(/\/$/, "");
    return url ? `${url}/analytics/v1/${path.replace(/^\//, "")}` : "";
  }
  function sendObservability(path, payload, preferBeacon = false) {
    const url = observabilityUrl(path);
    if (!url.startsWith("https://") || !firstPartyAllowed()) return;
    ownedDelivery.enqueue(String(payload.batch_id), url, payload, (receipt) => receipt.success === true);
    if (preferBeacon) ownedDelivery.beacon();
  }
  function canonicalEvent(value) {
    if (!value || typeof value !== "object") return false;
    const event = value;
    return event.schema_version === 2 && typeof event.event_id === "string" && Object.values(COMMERCE_EVENTS_V2).includes(event.event_name);
  }
  function queueEvent(event) {
    if (!firstPartyAllowed() || !canonicalEvent(event) || deliveredEventIds.has(event.event_id)) return;
    deliveredEventIds.add(event.event_id);
    if (deliveredEventIds.size > 500) deliveredEventIds = new Set(Array.from(deliveredEventIds).slice(-250));
    eventQueue.push(event);
    if (eventQueue.length > MAX_QUEUE_SIZE) eventQueue = eventQueue.slice(-MAX_QUEUE_SIZE);
    if (!flushTimer) flushTimer = setTimeout(flush, FLUSH_MS);
  }
  function flush() {
    if (flushTimer) {
      clearTimeout(flushTimer);
      flushTimer = null;
    }
    if (!firstPartyAllowed()) {
      eventQueue = [];
      return;
    }
    const url = collectUrl();
    if (!url.startsWith("https://") || !eventQueue.length) return;
    while (eventQueue.length) {
      const events = eventQueue.splice(0, 20);
      ownedDelivery.enqueue(events.map((event) => event.event_id).join(":"), url, { schema_version: 2, events }, (receipt) => receipt.success === true && receipt.action === "stored" && receipt.invalid_count === 0 && receipt.commerce_v2?.rejected === 0 && receipt.commerce_v2.stored + receipt.commerce_v2.duplicates === events.length);
    }
    if (document.visibilityState === "hidden") ownedDelivery.beacon();
  }
  function track(event) {
    queueEvent(event);
  }
  function duplicateWithin(key, milliseconds = 1500) {
    const now = Date.now();
    const previous = semanticDedupe.get(key) ?? 0;
    semanticDedupe.set(key, now);
    if (semanticDedupe.size > 200) semanticDedupe = new Map(Array.from(semanticDedupe).slice(-100));
    return now - previous < milliseconds;
  }
  function providerPush(event) {
    try {
      window.MC_GTM?.push(event);
    } catch {
    }
  }
  function providerEcommercePush(name, ecommercePayload, sourceEvent) {
    providerPush({
      event: name,
      event_id: sourceEvent.event_id,
      schema_version: sourceEvent.schema_version,
      source: sourceEvent.source,
      surface: sourceEvent.surface,
      consent: sourceEvent.consent,
      attribution: sourceEvent.attribution,
      ecommerce: ecommercePayload
    });
  }
  function ga4Item(line, index) {
    const quantity = Math.max(1, Number(line.quantity) || 1);
    const valueMinor = line.line_price != null ? Number(line.line_price) : (Number(line.price) || 0) * quantity;
    return {
      item_id: String(line.variant_id ?? line.id ?? ""),
      price: valueMinor / quantity / 100,
      quantity,
      index
    };
  }
  function ga4Items(cart) {
    return (cart.items ?? []).map((line, index) => ga4Item(line, index));
  }
  function commerceItems(lines) {
    return lines.map(commerceItemFromCartLine).filter((item) => item !== null);
  }
  function itemValue(items) {
    return items.reduce((sum, item) => sum + item.value_minor, 0);
  }
  function currency(value) {
    const normalized = value?.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 3);
    return normalized?.length === 3 ? normalized : ecomm().currency?.toUpperCase().slice(0, 3) || "EUR";
  }
  function trackPage() {
    const config = cfg();
    pageViewId = entityId("pgv");
    resetProductDecisionProofTracking();
    pageStartAt = Date.now();
    activeStartedAt = document.visibilityState === "visible" ? pageStartAt : 0;
    activeMilliseconds = 0;
    maxScrollPercent = 0;
    engagementRecorded = false;
    reportedActiveSeconds = 0;
    reportedScrollPercent = 0;
    vitalsFinalized = false;
    vitalValues.clear();
    vitalSent.clear();
    const surface = pageSurface();
    const pageEvent = createPageViewEvent(context(surface), {
      page_path: location.pathname,
      page_type: config.pageType ?? "unknown",
      referrer_host: referrerHost()
    }, compatibility());
    queueEvent(pageEvent);
    if (config.pageType === "product" && config.productHandle) {
      const productEvent = createProductViewEvent(context("product_buybox"), {
        product_handle: config.productHandle
      }, compatibility());
      queueEvent(productEvent);
      const item = ecomm().product;
      if (item) {
        providerEcommercePush("view_item", {
          currency: ecomm().currency,
          value: (item.price ?? 0) * (item.quantity ?? 1),
          items: [{ ...item, quantity: item.quantity ?? 1 }]
        }, productEvent);
      }
    } else if (config.pageType === "collection" && config.collectionHandle) {
      const collectionEvent = createCollectionViewEvent(context("storefront_page"), {
        collection_handle: config.collectionHandle
      }, compatibility());
      queueEvent(collectionEvent);
      if (ecomm().collection?.items?.length) {
        providerEcommercePush("view_item_list", {
          currency: ecomm().currency,
          item_list_id: ecomm().collection?.item_list_id,
          item_list_name: ecomm().collection?.item_list_name,
          items: ecomm().collection?.items
        }, collectionEvent);
      }
    } else if (config.pageType === "search" && config.searchQueryLength != null) {
      queueEvent(createSearchPerformedEvent(context("search_page"), {
        query_length: cleanInteger(config.searchQueryLength),
        result_count: config.searchResultCount == null ? void 0 : cleanInteger(config.searchResultCount)
      }, compatibility()));
    } else if (config.pageType === "cart") {
      const cart = ecomm().cart;
      const items = cart?.items ?? [];
      latestCart = {
        currency: ecomm().currency,
        item_count: cart?.item_count ?? config.cartItemCount ?? items.reduce((sum, item) => sum + (item.quantity ?? 1), 0),
        total_price: Math.round((cart?.value ?? 0) * 100)
      };
      const cartEvent = createCartViewEvent(context("cart_page"), {
        cart_surface: "page",
        item_count: latestCart.item_count ?? 0,
        value_minor: latestCart.total_price ?? 0,
        currency: currency(latestCart.currency)
      }, compatibility());
      queueEvent(cartEvent);
      if (items.length) {
        providerEcommercePush("view_cart", {
          currency: ecomm().currency,
          value: cart?.value,
          items
        }, cartEvent);
      }
    }
    initializeWebVitals();
  }
  function updateActiveTime() {
    if (!activeStartedAt) return;
    activeMilliseconds += Math.max(0, Date.now() - activeStartedAt);
    activeStartedAt = 0;
  }
  function finalizeEngagement() {
    if (!trackingActive || !pageStartAt) return;
    updateActiveTime();
    const summary = engagementSummary(activeMilliseconds, maxScrollPercent);
    if (engagementRecorded && summary.active_seconds === reportedActiveSeconds && summary.max_scroll_percent <= reportedScrollPercent) return;
    const checkpoint = engagementCheckpoint(activeMilliseconds, maxScrollPercent, reportedActiveSeconds);
    engagementRecorded = true;
    reportedActiveSeconds = summary.active_seconds;
    reportedScrollPercent = summary.max_scroll_percent;
    queueEvent(createPageEngagementEvent(context(pageSurface()), checkpoint.properties, compatibility()));
  }
  function onScroll() {
    if (!firstPartyAllowed()) return;
    const root = document.documentElement;
    const max = root.scrollHeight - root.clientHeight;
    if (max <= 0) return;
    maxScrollPercent = Math.max(maxScrollPercent, Math.round(root.scrollTop / max * 100));
  }
  function emitWebVital(name, value) {
    if (!Number.isFinite(value) || value < 0 || vitalSent.has(name)) return;
    vitalSent.add(name);
    const rounded = name === "CLS" ? Math.round(value * 1e3) / 1e3 : Math.round(value);
    queueEvent(createWebVitalEvent(context(pageSurface()), {
      metric_name: name,
      metric_value: rounded,
      rating: webVitalRating(name, rounded)
    }, compatibility()));
  }
  function observePerformance(type, callback) {
    try {
      const observer = new PerformanceObserver((list) => callback(list.getEntries()));
      observer.observe({ type, buffered: true });
    } catch {
    }
  }
  function initializeWebVitals() {
    try {
      const navigation = performance.getEntriesByType("navigation")[0];
      if (navigation && navigation.responseStart >= 0) emitWebVital("TTFB", navigation.responseStart);
    } catch {
    }
    observePerformance("paint", (entries) => {
      const fcp = entries.find((entry) => entry.name === "first-contentful-paint");
      if (fcp) emitWebVital("FCP", fcp.startTime);
    });
    observePerformance("largest-contentful-paint", (entries) => {
      const last = entries[entries.length - 1];
      if (last) vitalValues.set("LCP", last.startTime);
    });
    observePerformance("layout-shift", (entries) => {
      let cls = vitalValues.get("CLS") ?? 0;
      for (const entry of entries) {
        const shift = entry;
        if (!shift.hadRecentInput) cls += shift.value ?? 0;
      }
      vitalValues.set("CLS", cls);
    });
    observePerformance("event", (entries) => {
      let inp = vitalValues.get("INP") ?? 0;
      for (const entry of entries) inp = Math.max(inp, entry.duration || 0);
      if (inp > 0) vitalValues.set("INP", inp);
    });
  }
  function finalizeWebVitals() {
    if (vitalsFinalized) return;
    vitalsFinalized = true;
    for (const name of ["LCP", "INP", "CLS"]) {
      const value = vitalValues.get(name);
      if (value != null) emitWebVital(name, value);
    }
  }
  function surfaceForElement(element) {
    const declared = element?.closest("[data-mc-commerce-surface]")?.dataset.mcCommerceSurface;
    if (declared) return normalizeSurface(declared);
    if (element?.closest(".mc-product-buybox")) return "product_buybox";
    if (element?.closest(".mc-sticky-atc")) return "sticky_buybox";
    if (element?.closest("quick-add-product")) return "quick_add";
    if (element?.closest(".mc-xsell, [data-section-type='mc-cross-sell']")) return "cross_sell";
    if (element?.closest("[data-bundle-widget], [data-section-type='mc-bundle']")) return "bundle_builder";
    if (element?.closest("[data-mc-quiz-result], [data-mc-quiz-rec]")) return "quiz_result";
    if (element?.closest("[data-mc-quiz]")) return "quiz";
    if (element?.closest("cart-drawer, .cart-drawer")) return "cart_drawer";
    if (element?.closest("[data-cart-page], .cart-page")) return "cart_page";
    return pageSurface();
  }
  function ctaSurfaceForElement(element) {
    return element?.closest("[data-mc-sticky-atc-btn], .mc-sticky-atc") ? "sticky" : "primary";
  }
  function productHandleForElement(element) {
    return cleanString(
      element?.closest("[data-mc-product-handle]")?.dataset.mcProductHandle ?? cfg().productHandle,
      120
    );
  }
  function rememberAction(target) {
    const element = target instanceof Element ? target : null;
    const root = element?.closest("[data-mc-product-handle], .mc-product-buybox, product-form");
    const variant = root?.querySelector("[name='id'], [data-mc-variant-id], .product-variant-id");
    pendingCommerceAction = {
      surface: surfaceForElement(element),
      productHandle: productHandleForElement(element),
      variantId: cleanString(variant?.value, 80),
      at: Date.now()
    };
  }
  function emitAddToCartFailure(surface, errorType, action = currentAction()) {
    queueEvent(createAddToCartFailedEvent(context(surface), {
      product_handle: action?.productHandle,
      variant_id: action?.variantId,
      error_type: errorType.slice(0, 80)
    }, compatibility()));
  }
  function productIdentity(element) {
    const root = element?.closest("[data-mc-product-handle], .mc-product-buybox, product-form");
    const productHandle = productHandleForElement(element);
    const variant = root?.querySelector("[name='id'], [data-mc-variant-id], .product-variant-id");
    return { productHandle, variantId: cleanString(variant?.value, 80) };
  }
  function initializeProductVisibilityTracking() {
    if (!("IntersectionObserver" in window)) return;
    if (!productVisibilityObserver) {
      productVisibilityObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          const element = entry.target;
          const { productHandle, variantId } = productIdentity(element);
          if (!productHandle) return;
          if (element.matches("[data-mc-product-buybox-track]")) {
            queueEvent(createProductBuyboxViewedEvent(context("product_buybox"), {
              product_handle: productHandle
            }, compatibility()));
          } else {
            if (viewedProductCtas.has(element)) return;
            viewedProductCtas.add(element);
            queueEvent(createProductCtaViewedEvent(context(surfaceForElement(element)), {
              product_handle: productHandle,
              variant_id: variantId,
              cta_type: "add_to_cart",
              cta_surface: ctaSurfaceForElement(element)
            }, compatibility()));
          }
          observer.unobserve(element);
        });
      }, { threshold: [0.5] });
    }
    document.querySelectorAll("[data-mc-product-buybox-track], [data-mc-atc], [data-mc-sticky-atc-btn]").forEach((element) => {
      if (observedProductElements.has(element)) return;
      observedProductElements.add(element);
      productVisibilityObserver?.observe(element);
    });
  }
  function trustModuleForElement(element) {
    return element?.closest("[data-mc-product-trust-module]") ?? null;
  }
  function trustPlacementForElement(element) {
    const declared = element?.closest("[data-mc-trust-placement]")?.dataset.mcTrustPlacement;
    return cleanSemanticKey(declared);
  }
  function reviewCountForElement(element) {
    const declared = element?.closest("[data-mc-review-count]")?.dataset.mcReviewCount;
    return cleanNullableCount(declared);
  }
  function trustDestinationType(element) {
    const declared = cleanSemanticKey(element.dataset.mcTrustDestinationType);
    if (declared === "anchor" || declared === "accordion" || declared === "page") return declared;
    const anchor = element.matches("a[href]") ? element : element.querySelector("a[href]");
    if (anchor) {
      try {
        const destination = new URL(anchor.href, location.href);
        return destination.pathname === location.pathname && Boolean(destination.hash) ? "anchor" : "page";
      } catch {
        return void 0;
      }
    }
    if (element.matches("summary,button,[role='button']") || element.querySelector("summary,button,[role='button']")) {
      return "accordion";
    }
    return void 0;
  }
  function productDecisionProofAlreadyViewed(kind) {
    return kind === "trust_module" ? productTrustModuleViewed : productReviewSectionViewed;
  }
  function cancelProductDecisionProofTimer(state) {
    if (state.timer) clearTimeout(state.timer);
    state.timer = null;
  }
  function stopObservingProductDecisionProofKind(kind) {
    for (const [element, state] of productDecisionProofVisibility) {
      if (state.kind !== kind) continue;
      cancelProductDecisionProofTimer(state);
      productDecisionProofObserver?.unobserve(element);
      productDecisionProofVisibility.delete(element);
    }
  }
  function emitProductDecisionProofViewed(element, kind) {
    const productHandle = productHandleForElement(element);
    if (!productHandle || productDecisionProofAlreadyViewed(kind)) return;
    if (kind === "trust_module") {
      const moduleKey = cleanSemanticKey(element.dataset.mcTrustModuleKey);
      const placement = trustPlacementForElement(element);
      const moduleRevision = cleanInteger(element.dataset.mcTrustModuleRevision);
      if (!moduleKey || !placement || moduleRevision < 1 || moduleRevision > 1e4) return;
      const evidenceCount = Math.min(20, element.querySelectorAll("[data-mc-product-trust-item]").length);
      queueEvent(createProductTrustModuleViewedEvent(context(surfaceForElement(element)), {
        product_handle: productHandle,
        module_key: moduleKey,
        module_revision: moduleRevision,
        placement,
        evidence_count: evidenceCount,
        review_count: reviewCountForElement(element)
      }, compatibility()));
      productTrustModuleViewed = true;
    } else {
      queueEvent(createProductReviewSectionViewedEvent(context(surfaceForElement(element)), {
        product_handle: productHandle,
        review_count: reviewCountForElement(element)
      }, compatibility()));
      productReviewSectionViewed = true;
    }
    stopObservingProductDecisionProofKind(kind);
  }
  function scheduleProductDecisionProofView(element, state) {
    if (state.timer || productDecisionProofAlreadyViewed(state.kind) || document.visibilityState !== "visible") return;
    state.timer = setTimeout(() => {
      state.timer = null;
      if (document.visibilityState === "visible" && state.ratio >= PRODUCT_DECISION_PROOF_VISIBILITY_RATIO && element.isConnected) emitProductDecisionProofViewed(element, state.kind);
    }, PRODUCT_DECISION_PROOF_VISIBILITY_MS);
  }
  function pauseProductDecisionProofVisibility() {
    for (const state of productDecisionProofVisibility.values()) cancelProductDecisionProofTimer(state);
  }
  function resumeProductDecisionProofVisibility() {
    for (const [element, state] of productDecisionProofVisibility) {
      if (state.ratio >= PRODUCT_DECISION_PROOF_VISIBILITY_RATIO) {
        scheduleProductDecisionProofView(element, state);
      }
    }
  }
  function resetProductDecisionProofTracking() {
    pauseProductDecisionProofVisibility();
    productDecisionProofObserver?.disconnect();
    productDecisionProofVisibility.clear();
    observedProductDecisionProofElements = /* @__PURE__ */ new WeakSet();
    productTrustModuleViewed = false;
    productReviewSectionViewed = false;
  }
  function initializeProductDecisionProofTracking() {
    if (!("IntersectionObserver" in window)) return;
    if (!productDecisionProofObserver) {
      productDecisionProofObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          const element = entry.target;
          const state = productDecisionProofVisibility.get(element);
          if (!state) continue;
          state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          if (state.ratio >= PRODUCT_DECISION_PROOF_VISIBILITY_RATIO) {
            scheduleProductDecisionProofView(element, state);
          } else {
            cancelProductDecisionProofTimer(state);
          }
        }
      }, { threshold: [PRODUCT_DECISION_PROOF_VISIBILITY_RATIO] });
    }
    const targets = [
      ["[data-mc-product-trust-module]", "trust_module"],
      ["[data-mc-product-review-section]", "review_section"]
    ];
    for (const [selector, kind] of targets) {
      document.querySelectorAll(selector).forEach((element) => {
        if (observedProductDecisionProofElements.has(element) || productDecisionProofAlreadyViewed(kind)) return;
        observedProductDecisionProofElements.add(element);
        productDecisionProofVisibility.set(element, { kind, ratio: 0, timer: null });
        productDecisionProofObserver?.observe(element);
      });
    }
  }
  function initializeProductDetailTracking() {
    document.querySelectorAll("details[data-mc-product-detail]").forEach((detail) => {
      if (observedProductDetails.has(detail)) return;
      observedProductDetails.add(detail);
      detail.querySelector("summary")?.addEventListener("click", () => {
        pendingProductDetailToggles.set(detail, Date.now());
      });
      detail.addEventListener("toggle", () => {
        const requestedAt = pendingProductDetailToggles.get(detail);
        if (!requestedAt || Date.now() - requestedAt > 2e3) return;
        pendingProductDetailToggles.delete(detail);
        const productHandle = productHandleForElement(detail);
        const detailKey = cleanString(detail.dataset.mcDetailKey, 100);
        const detailTitle = cleanString(detail.dataset.mcDetailTitle, 160);
        if (!productHandle || !detailKey || !detailTitle) return;
        queueEvent(createProductDetailToggledEvent(context("product_buybox"), {
          product_handle: productHandle,
          detail_key: detailKey,
          detail_title: detailTitle,
          detail_position: Math.max(1, cleanInteger(detail.dataset.mcDetailPosition, 1)),
          state: detail.open ? "opened" : "closed"
        }, compatibility()));
      });
    });
  }
  function onWelcomePopupViewed(event) {
    const detail = event.detail ?? {};
    const trigger = detail.trigger === "form_state" ? "form_state" : "timer";
    queueEvent(createWelcomePopupViewedEvent(context("welcome_popup"), {
      trigger,
      delay_seconds: cleanInteger(detail.delay_seconds, 20)
    }, compatibility()));
  }
  function onWelcomePopupClosed(event) {
    const detail = event.detail ?? {};
    const allowed = /* @__PURE__ */ new Set(["close_button", "overlay", "escape", "cta"]);
    const closeReason = allowed.has(detail.close_reason ?? "") ? detail.close_reason : "close_button";
    queueEvent(createWelcomePopupClosedEvent(context("welcome_popup"), {
      close_reason: closeReason,
      active_seconds: cleanInteger(detail.active_seconds)
    }, compatibility()));
  }
  function onProductGalleryNavigated(event) {
    const target = event.target instanceof Element ? event.target : null;
    const detail = event.detail ?? {};
    const productHandle = productHandleForElement(target);
    const allowed = /* @__PURE__ */ new Set(["swipe", "previous", "next", "thumbnail"]);
    if (!productHandle || !allowed.has(String(detail.interaction))) return;
    queueEvent(createProductGalleryNavigatedEvent(context("product_buybox"), {
      product_handle: productHandle,
      interaction: detail.interaction,
      from_index: cleanInteger(detail.from_index),
      to_index: cleanInteger(detail.to_index),
      media_id: cleanString(detail.media_id, 100)
    }, compatibility()));
  }
  function onDogSizeSelected(event) {
    const target = event.target instanceof Element ? event.target : null;
    const detail = event.detail ?? {};
    const productHandle = productHandleForElement(target);
    const sizeLabel = cleanString(detail.size_label, 80);
    if (!productHandle || !sizeLabel) return;
    queueEvent(createDogSizeSelectedEvent(context("product_buybox"), {
      product_handle: productHandle,
      size_label: sizeLabel,
      scoop_count: Math.max(1, cleanInteger(detail.scoop_count, 1)),
      selection_count: Math.max(1, cleanInteger(detail.selection_count, 1))
    }, compatibility()));
  }
  function currentAction() {
    if (!pendingCommerceAction || Date.now() - pendingCommerceAction.at > 5e3) return void 0;
    return pendingCommerceAction;
  }
  function newsletterForm(target) {
    const element = target instanceof Element ? target : null;
    return element?.closest("form[data-mc-newsletter-form], form[data-newsletter-form]") ?? null;
  }
  function newsletterPlacement(form) {
    return (form.dataset.mcNewsletterPlacement || form.dataset.newsletterPlacement || "unknown").toLowerCase().replace(/[^a-z0-9_-]/g, "_").slice(0, 80);
  }
  function newsletterSurface(placement) {
    if (placement === "footer") return "footer_newsletter";
    if (placement === "welcome_popup") return "welcome_popup";
    if (placement === "wissen") return "wissen_newsletter";
    if (placement === "quiz") return "quiz_newsletter";
    if (placement === "article") return "article_newsletter";
    if (placement === "password") return "password_newsletter";
    return "unknown";
  }
  function newsletterOptInSelected(form) {
    const input = form.querySelector('input[name="contact[accepts_marketing]"]');
    return !input || input.type !== "checkbox" || input.checked;
  }
  function trackNewsletterSubmitted(form) {
    if (!form.checkValidity() || !newsletterOptInSelected(form)) return;
    const placement = newsletterPlacement(form);
    queueEvent(createNewsletterSignupSubmittedEvent(context(newsletterSurface(placement)), { placement }, compatibility()));
    flush();
  }
  function trackNewsletterOutcomes() {
    document.querySelectorAll("form[data-mc-newsletter-form], form[data-newsletter-form]").forEach((form) => {
      const marker = form.querySelector("[data-mc-newsletter-outcome]");
      const state = marker?.dataset.mcNewsletterOutcome || form.dataset.mcNewsletterState;
      if (state !== "accepted" && state !== "failed") return;
      const placement = newsletterPlacement(form);
      const key = `${pageViewId}:${form.id}:${state}`;
      if (newsletterOutcomeKeys.has(key)) return;
      newsletterOutcomeKeys.add(key);
      if (state === "accepted") {
        queueEvent(createNewsletterSignupAcceptedEvent(context(newsletterSurface(placement)), { placement }, compatibility()));
      } else {
        queueEvent(createNewsletterSignupFailedEvent(context(newsletterSurface(placement)), {
          placement,
          error_type: "shopify_form_error"
        }, compatibility()));
      }
    });
  }
  function trackLifecycleForm(form) {
    if (!form.checkValidity()) return false;
    if (form.matches("[data-mc-waitlist-form]")) {
      const productHandle = cleanString(form.dataset.mcProductHandle, 120);
      if (!productHandle) return true;
      queueEvent(createWaitlistSignupSubmittedEvent(context("product_waitlist"), {
        product_handle: productHandle,
        placement: cleanString(form.dataset.mcPlacement, 80) ?? "product_waitlist"
      }, compatibility()));
      return true;
    }
    if (form.matches("[data-mc-back-in-stock-form]")) {
      const productHandle = cleanString(form.dataset.mcProductHandle, 120);
      if (!productHandle) return true;
      queueEvent(createBackInStockRequestedEvent(context("back_in_stock"), {
        product_handle: productHandle,
        variant_id: cleanString(form.dataset.mcVariantId, 80)
      }, compatibility()));
      return true;
    }
    return false;
  }
  function cartSurface(surface) {
    if (surface === "cart_drawer") return "drawer";
    if (surface === "cart_sticky") return "sticky";
    return "page";
  }
  async function fetchCart(fetchImpl = window.fetch.bind(window)) {
    try {
      const response = await fetchImpl("/cart.js", { credentials: "same-origin" });
      if (!response.ok) return void 0;
      latestCart = await response.json();
      return latestCart;
    } catch {
      return void 0;
    }
  }
  async function emitCartView(surface) {
    if (duplicateWithin(`cart_view:${surface}`, 1e3)) return;
    const cart = await fetchCart();
    if (!cart) return;
    const event = createCartViewEvent(context(surface), {
      cart_surface: cartSurface(surface),
      item_count: cleanInteger(cart.item_count),
      value_minor: cleanInteger(cart.total_price),
      currency: currency(cart.currency)
    }, compatibility());
    queueEvent(event);
    providerEcommercePush("view_cart", {
      currency: currency(cart.currency),
      value: cleanInteger(cart.total_price) / 100,
      items: ga4Items(cart)
    }, event);
  }
  async function emitCheckoutIntent(surface) {
    if (duplicateWithin("checkout_intent", 2e3)) return;
    const cart = latestCart ?? await fetchCart();
    const itemCount = cleanInteger(cart?.item_count ?? cfg().cartItemCount ?? ecomm().cart?.item_count);
    const event = createCheckoutIntentSubmittedEvent(context(surface), {
      cart_surface: cartSurface(surface),
      item_count: itemCount
    }, compatibility());
    queueEvent(event);
    providerEcommercePush("begin_checkout", {
      currency: currency(cart?.currency),
      value: cleanInteger(cart?.total_price) / 100,
      items: cart ? ga4Items(cart) : ecomm().cart?.items ?? []
    }, event);
    flush();
  }
  function onClick(event) {
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    rememberAction(element);
    const reviewSummary = element.closest("[data-mc-product-review-summary]");
    if (reviewSummary) {
      const productHandle = productHandleForElement(reviewSummary);
      if (productHandle && reviewSummary.closest("[data-mc-product-buybox-track], .mc-product-buybox")) {
        queueEvent(createProductReviewSummaryClickedEvent(context(surfaceForElement(reviewSummary)), {
          product_handle: productHandle,
          placement: "buybox",
          review_count: reviewCountForElement(reviewSummary)
        }, compatibility()));
      }
    }
    const trustItem = element.closest("[data-mc-product-trust-item]");
    if (trustItem) {
      const module = trustModuleForElement(trustItem);
      const productHandle = productHandleForElement(trustItem);
      const moduleKey = cleanSemanticKey(module?.dataset.mcTrustModuleKey);
      const itemKey = cleanSemanticKey(trustItem.dataset.mcTrustItemKey);
      const placement = trustPlacementForElement(trustItem);
      const destinationType = trustDestinationType(trustItem);
      if (productHandle && moduleKey && itemKey && placement && destinationType) {
        queueEvent(createProductTrustItemClickedEvent(context(surfaceForElement(trustItem)), {
          product_handle: productHandle,
          module_key: moduleKey,
          item_key: itemKey,
          placement,
          destination_type: destinationType
        }, compatibility()));
      }
    }
    const addToCartControl = element.closest("[data-mc-atc], [data-mc-sticky-atc-btn]");
    if (addToCartControl) {
      const { productHandle, variantId } = productIdentity(addToCartControl);
      if (productHandle) {
        queueEvent(createProductCtaClickedEvent(context(surfaceForElement(addToCartControl)), {
          product_handle: productHandle,
          variant_id: variantId,
          cta_type: "add_to_cart",
          cta_surface: ctaSurfaceForElement(addToCartControl)
        }, compatibility()));
      }
    }
    const tier = element.closest("[data-mc-tier]");
    if (tier) {
      queueMicrotask(() => {
        const root = tier.closest("[data-mc-product-handle], .mc-product-buybox");
        const variant = root?.querySelector("[data-mc-variant-id], .product-variant-id");
        const productHandle = productHandleForElement(tier);
        if (productHandle && variant?.value && !duplicateWithin(`variant:${variant.value}:${surfaceForElement(tier)}`)) {
          queueEvent(createVariantSelectedEvent(context(surfaceForElement(tier)), {
            product_handle: productHandle,
            variant_id: variant.value
          }, compatibility()));
        }
        const count = Math.max(1, cleanInteger(tier.dataset.mcTier, 1));
        queueEvent(createBundleConfiguredEvent(context(surfaceForElement(tier)), {
          bundle_type: "pack_variant",
          item_count: count
        }, compatibility()));
      });
    }
    const anchor = element.closest("a[href]");
    if (anchor?.href) {
      try {
        const link = new URL(anchor.href, location.href);
        if (link.hostname && link.hostname !== location.hostname) {
          queueEvent(createOutboundClickEvent(context("external_link"), {
            destination_host: link.hostname.replace(/^www\./, "").slice(0, 120)
          }, compatibility()));
        }
        if (link.pathname.includes("/checkout")) void emitCheckoutIntent(surfaceForElement(anchor));
      } catch {
      }
    }
    const checkoutControl = element.closest("button[name='checkout'], input[name='checkout'], [data-checkout-button]");
    if (checkoutControl) void emitCheckoutIntent(surfaceForElement(checkoutControl));
  }
  function onChange(event) {
    const input = event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement ? event.target : null;
    if (!input) return;
    const sellingPlanControl = input.matches("[name='selling_plan'], [data-selling-plan-id], [data-mc-purchase-mode]");
    if (sellingPlanControl) {
      const value = input.value || input.getAttribute("data-selling-plan-id") || "";
      const mode = value && value !== "0" && value !== "one_time" ? "subscription" : "one_time";
      if (!duplicateWithin(`subscription:${mode}:${value}`)) {
        queueEvent(createSubscriptionSelectedEvent(context("subscription_selector"), {
          purchase_mode: mode,
          selling_plan_id: mode === "subscription" ? cleanString(value, 80) : void 0
        }, compatibility()));
      }
      return;
    }
    if (!input.matches("[name='id'], [data-mc-variant-id], .product-variant-id, [data-mc-option-index]")) return;
    queueMicrotask(() => {
      const root = input.closest("[data-mc-product-handle], .mc-product-buybox, product-form");
      const variant = root?.querySelector("[name='id'], [data-mc-variant-id], .product-variant-id");
      const productHandle = productHandleForElement(input);
      if (!variant?.value || !productHandle || duplicateWithin(`variant:${variant.value}:${surfaceForElement(input)}`)) return;
      queueEvent(createVariantSelectedEvent(context(surfaceForElement(input)), {
        product_handle: productHandle,
        variant_id: variant.value
      }, compatibility()));
    });
  }
  function onSubmit(event) {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    rememberAction(form);
    if (trackLifecycleForm(form)) return;
    const newsletter = newsletterForm(form);
    if (newsletter) trackNewsletterSubmitted(newsletter);
    const submitter = event.submitter;
    if (submitter?.matches("[name='checkout']") || form.action.includes("/checkout")) {
      void emitCheckoutIntent(surfaceForElement(submitter ?? form));
    }
  }
  function emitUserFacingError(surface, contextName, errorType) {
    queueEvent(createUserFacingErrorEvent(context(surface), {
      error_context: contextName.slice(0, 80),
      error_type: errorType.slice(0, 80)
    }, compatibility()));
  }
  function interceptCartFetch() {
    if (fetchIntercepted) return;
    fetchIntercepted = true;
    const original = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const request = args[0];
      const url = typeof request === "string" ? request : request instanceof Request ? request.url : "";
      const body = args[1]?.body;
      const isAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
      const isChange = /\/cart\/(?:change|update)(?:\.js)?(?:\?|$)/.test(url);
      const mutation = isChange ? parseCartMutationBody(body) : {};
      let beforeCart;
      let changedLine;
      if (isChange && mutation.quantity != null) {
        beforeCart = await fetchCart(original);
        changedLine = findChangedCartLine(beforeCart?.items, mutation);
      }
      let response;
      try {
        response = await original(...args);
      } catch (error) {
        if (isAdd) {
          const action2 = currentAction();
          emitAddToCartFailure(action2?.surface ?? pageSurface(), "network_error", action2);
          emitUserFacingError(action2?.surface ?? pageSurface(), "add_to_cart", "network_error");
        }
        throw error;
      }
      const action = currentAction();
      const surface = action?.surface ?? pageSurface();
      if ((isAdd || isChange) && !response.ok) {
        if (isAdd) emitAddToCartFailure(surface, `http_${response.status}`, action);
        emitUserFacingError(surface, isAdd ? "add_to_cart" : "cart_update", `http_${response.status}`);
        return response;
      }
      try {
        if (isAdd && response.ok) {
          const json = await response.clone().json();
          const lines = cartAddLines(json);
          const items = commerceItems(lines);
          if (items.length) {
            const event = createAddToCartEvent(context(surface), {
              items,
              value_minor: itemValue(items),
              currency: currency(latestCart?.currency)
            }, compatibility());
            queueEvent(event);
            flush();
            providerEcommercePush("add_to_cart", {
              currency: currency(latestCart?.currency),
              value: itemValue(items) / 100,
              items: lines.map(ga4Item)
            }, event);
            void fetchCart(original);
            if (items.length > 1 && surface !== "quiz_result") {
              queueEvent(createBundleConfiguredEvent(context(surface), {
                bundle_type: "multi_item",
                item_count: items.reduce((sum, item) => sum + item.quantity, 0)
              }, compatibility()));
            }
            void syncCartAttributes(true, original);
          }
        }
        if (isChange && response.ok && mutation.quantity != null && changedLine) {
          const oldQuantity = Math.max(0, cleanInteger(changedLine.quantity));
          const removedQuantity = Math.max(0, oldQuantity - mutation.quantity);
          if (removedQuantity > 0) {
            const unitValue = oldQuantity > 0 ? Math.round((changedLine.line_price ?? (changedLine.price ?? 0) * oldQuantity) / oldQuantity) : cleanInteger(changedLine.price);
            const baseItem = commerceItemFromCartLine(changedLine);
            if (baseItem) {
              const item = {
                ...baseItem,
                quantity: removedQuantity,
                value_minor: unitValue * removedQuantity
              };
              const afterCart = await fetchCart(original);
              const event = createRemoveFromCartEvent(context(surface), {
                items: [item],
                value_minor: item.value_minor,
                currency: currency(afterCart?.currency ?? beforeCart?.currency)
              }, compatibility());
              queueEvent(event);
              providerEcommercePush("remove_from_cart", {
                currency: currency(afterCart?.currency ?? beforeCart?.currency),
                value: item.value_minor / 100,
                items: [{ ...ga4Item(changedLine), quantity: removedQuantity }]
              }, event);
            }
          }
        }
      } catch {
        if (isAdd) emitAddToCartFailure(surface, "invalid_shopify_response", action);
        emitUserFacingError(surface, isAdd ? "add_to_cart" : "cart_update", "invalid_shopify_response");
      }
      return response;
    };
  }
  function cartAttributeValue(value) {
    return cleanString(value, 160) ?? "";
  }
  function getCartAttributes() {
    const attributes = {};
    for (const key of FIRST_PARTY_CART_ATTRIBUTE_KEYS) attributes[key] = "";
    for (const key of ANALYTICS_CART_ATTRIBUTE_KEYS) attributes[key] = "";
    for (const key of ATTRIBUTION_CART_ATTRIBUTE_KEYS) attributes[key] = "";
    if (analyticsAllowed()) {
      const ga = gaContextFromCookieString(document.cookie);
      if (ga.client_id) attributes.__mc_ga_client_id = ga.client_id;
      if (ga.session_id) attributes.__mc_ga_session_id = ga.session_id;
    }
    if (!attributionStorageAllowed()) return attributes;
    const snapshot = getAttribution();
    for (const [model, touch] of [
      ["first", snapshot.first_touch],
      ["last", snapshot.last_non_direct],
      ["current", snapshot.current_touch]
    ]) {
      if (!touch) continue;
      for (const field of ATTRIBUTION_FIELDS) {
        const value = cartAttributeValue(touch[field]);
        if (value) attributes[`__mc_attr_${model}_${field}`] = value;
      }
      if (touch.referrer_host) attributes[`__mc_attr_${model}_referrer_host`] = cartAttributeValue(touch.referrer_host);
      attributes[`__mc_attr_${model}_captured_at`] = cartAttributeValue(touch.captured_at);
    }
    return attributes;
  }
  async function syncCartAttributes(force = false, fetchImpl = window.fetch.bind(window)) {
    if (cfg().pageType === "password" || location.pathname === "/password") return;
    const cartStorageAllowed = attributionStorageAllowed() || analyticsAllowed();
    if (!force && !cartStorageAllowed) return;
    const attributes = getCartAttributes();
    if (!Object.keys(attributes).length) return;
    const signature = JSON.stringify(attributes);
    try {
      if (!lastCartAttributeSignature) lastCartAttributeSignature = sessionStorage.getItem(CART_ATTR_SYNC_KEY) ?? "";
    } catch {
    }
    if (!force && signature === lastCartAttributeSignature) return;
    try {
      const response = await fetchImpl("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) return;
      lastCartAttributeSignature = signature;
      try {
        if (cartStorageAllowed) sessionStorage.setItem(CART_ATTR_SYNC_KEY, signature);
        else sessionStorage.removeItem(CART_ATTR_SYNC_KEY);
      } catch {
      }
    } catch {
    }
  }
  function productRecommendationStarted(input) {
    const flowId = cleanString(input.flow_id, 80);
    if (!flowId || duplicateWithin(`recommendation:start:${flowId}`, 3e4)) return;
    queueEvent(createProductRecommendationStartedEvent(context(input.surface ?? "quiz"), { flow_id: flowId }, compatibility()));
  }
  function productRecommendationStepCompleted(input) {
    const flowId = cleanString(input.flow_id, 80);
    const stepKey = cleanString(input.step_key, 80);
    if (!flowId || !stepKey) return;
    const index = Math.max(0, cleanInteger(input.step_index));
    if (duplicateWithin(`recommendation:step:${flowId}:${stepKey}:${index}`)) return;
    queueEvent(createProductRecommendationStepCompletedEvent(context(input.surface ?? "quiz"), {
      flow_id: flowId,
      step_key: stepKey,
      step_index: index
    }, compatibility()));
  }
  function productRecommendationCompleted(input) {
    const flowId = cleanString(input.flow_id, 80);
    const productHandle = cleanString(input.recommended_product_handle, 120);
    if (!flowId || !productHandle || duplicateWithin(`recommendation:complete:${flowId}:${productHandle}`, 3e4)) return;
    queueEvent(createProductRecommendationCompletedEvent(context(input.surface ?? "quiz_result"), {
      flow_id: flowId,
      recommended_product_handle: productHandle
    }, compatibility()));
  }
  function experimentVariantViewed(input) {
    const experimentId = cleanString(input.experiment_id, 120);
    const variantId = cleanString(input.variant_id, 120);
    const exposureSurface = cleanString(input.exposure_surface, 120) ?? "storefront_page";
    const revision = cleanInteger(input.experiment_revision);
    if (!experimentId || !variantId || revision < 1) return;
    if (!["first_party", "url_bound", "provider_randomized"].includes(input.assignment_type)) return;
    if (duplicateWithin(`experiment:${experimentId}:${revision}:${variantId}:${pageViewId}`, 3e4)) return;
    queueEvent(createExperimentVariantViewedEvent(context(pageSurface()), {
      experiment_id: experimentId,
      experiment_revision: revision,
      variant_id: variantId,
      assignment_type: input.assignment_type,
      exposure_surface: exposureSurface
    }, compatibility()));
  }
  function trackUrlBoundExperimentExposure() {
    const experimentId = cleanUrlParam("mc_experiment", 120);
    const variantId = cleanUrlParam("mc_variant", 120);
    const revision = Number(cleanUrlParam("mc_experiment_revision", 20));
    const requestedAssignment = cleanUrlParam("mc_assignment_type", 40);
    const assignmentType = requestedAssignment === "provider_randomized" ? "provider_randomized" : "url_bound";
    if (!experimentId || !variantId || !Number.isInteger(revision) || revision < 1) return;
    experimentVariantViewed({
      experiment_id: experimentId,
      experiment_revision: revision,
      variant_id: variantId,
      assignment_type: assignmentType,
      exposure_surface: cfg().pageType ?? "storefront_page"
    });
  }
  function applyFirstPartyExperimentAssignment(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return;
    const assignment = value;
    const experimentId = cleanString(assignment.experiment_id, 120);
    const variantId = cleanString(assignment.variant_id, 120);
    const revision = cleanInteger(assignment.experiment_revision);
    const publicConfig = assignment.public_config && typeof assignment.public_config === "object" && !Array.isArray(assignment.public_config) ? assignment.public_config : {};
    const unknownConfigKeys = Object.keys(publicConfig).filter((key) => key !== "body_class");
    const bodyClass = cleanString(publicConfig.body_class, 120);
    if (!experimentId || !variantId || revision < 1 || assignment.assignment_type !== "first_party" || unknownConfigKeys.length || bodyClass && !/^mc-exp-[a-z0-9][a-z0-9_-]{1,110}$/.test(bodyClass)) return;
    if (bodyClass) document.documentElement.classList.add(bodyClass);
    if (!document.dispatchEvent(new CustomEvent("mc:experiment-assignment", { detail: assignment, cancelable: true }))) return;
    experimentVariantViewed({
      experiment_id: experimentId,
      experiment_revision: revision,
      variant_id: variantId,
      assignment_type: "first_party",
      exposure_surface: cfg().pageType ?? "storefront_page"
    });
  }
  async function loadFirstPartyExperimentAssignments() {
    if (!firstPartyAllowed()) return;
    const url = observabilityUrl(`experiments?page_path=${encodeURIComponent(location.pathname)}`);
    if (!url.startsWith("https://")) return;
    try {
      const response = await fetch(url, { method: "GET", credentials: "omit" });
      if (!response.ok) return;
      const body = await response.json();
      for (const assignment of body.assignments ?? []) {
        applyFirstPartyExperimentAssignment(assignment);
      }
    } catch {
    }
  }
  function stableMapKey(element) {
    const mappedInteractive = element?.closest("[data-mc-map-interactive='true'][data-mc-map-key]");
    const explicit = cleanString(mappedInteractive?.dataset.mcMapKey, 120);
    if (explicit && /^[a-zA-Z0-9][a-zA-Z0-9:_-]*$/.test(explicit)) return explicit;
    const analyticsSurface = element?.closest("[data-mc-analytics-surface]")?.dataset.mcAnalyticsSurface;
    if (analyticsSurface && /^[a-zA-Z0-9_-]+$/.test(analyticsSurface)) return `surface:${analyticsSurface}`;
    const interactive = element?.closest("button,a,[role='button'],summary,input,select,textarea");
    if (interactive) {
      const role = interactive.getAttribute("type") || interactive.tagName.toLowerCase();
      const id = cleanString(interactive.id, 60)?.replace(/[^a-zA-Z0-9_-]/g, "-");
      return `control:${role}${id ? `:${id}` : ""}`;
    }
    const mappedSurface = element?.closest("[data-mc-map-key]:not([data-mc-map-section])");
    const surfaceKey = cleanString(mappedSurface?.dataset.mcMapKey, 120);
    if (surfaceKey && /^[a-zA-Z0-9][a-zA-Z0-9:_-]*$/.test(surfaceKey)) return surfaceKey;
    const mappedSection = element?.closest("[data-mc-map-section][data-mc-map-key]");
    const sectionKey = cleanString(mappedSection?.dataset.mcMapKey, 120);
    if (sectionKey && /^[a-zA-Z0-9][a-zA-Z0-9:_-]*$/.test(sectionKey)) return sectionKey;
    return "unmapped";
  }
  function prepareMapTargets() {
    const fixed = [
      ["[data-mc-product-buybox-track]", "product:buybox", false],
      ["[data-mc-atc]", "product:add-to-cart", true],
      ["[data-mc-sticky-atc-btn]", "product:sticky-add-to-cart", true],
      ["[data-mc-product-review-summary]", "product:review-summary", true],
      ["[data-mc-gallery-prev]", "product:gallery-prev", true],
      ["[data-mc-gallery-next]", "product:gallery-next", true],
      ["[data-mc-product-size]", "product:dog-size", true],
      ["[data-mc-product-detail]", "product:detail", true],
      ["[data-v6-open]", "product:package-open", true],
      ["[data-v6-close]", "product:package-close", true],
      ["[data-mc-welcome]", "welcome:popup", false]
    ];
    for (const [selector, key, interactive] of fixed) {
      for (const element of document.querySelectorAll(selector)) {
        if (!element.dataset.mcMapKey) element.dataset.mcMapKey = key;
        if (interactive) element.dataset.mcMapInteractive = "true";
      }
    }
    for (const element of document.querySelectorAll("[data-mc-product-trust-module]")) {
      const moduleKey = cleanSemanticKey(element.dataset.mcTrustModuleKey) ?? "unmapped";
      if (!element.dataset.mcMapKey) element.dataset.mcMapKey = `product:trust-module:${moduleKey}`;
      element.dataset.mcMapSection = "true";
    }
    for (const element of document.querySelectorAll("[data-mc-product-trust-item]")) {
      const itemKey = cleanSemanticKey(element.dataset.mcTrustItemKey) ?? "unmapped";
      if (!element.dataset.mcMapKey) element.dataset.mcMapKey = `product:trust-item:${itemKey}`;
      element.dataset.mcMapInteractive = "true";
    }
    for (const element of document.querySelectorAll("[data-mc-product-review-section]")) {
      if (!element.dataset.mcMapKey) element.dataset.mcMapKey = "product:review-section";
      element.dataset.mcMapSection = "true";
    }
    for (const section of document.querySelectorAll("[id^='shopify-section-']")) {
      if (section.querySelector("[data-mc-map-section]")) continue;
      const suffix = section.id.replace(/^shopify-section-/, "").replace(/[^a-zA-Z0-9_-]/g, "-").slice(-100);
      if (!section.dataset.mcMapKey) section.dataset.mcMapKey = `section:${suffix}`;
      section.dataset.mcMapSection = "true";
    }
  }
  function recordUxPointer(event) {
    if (!firstPartyAllowed() || event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    const targetKey = stableMapKey(target);
    const interactive = Boolean(target?.closest("button,a,[role='button'],summary,input,select,textarea,[data-mc-map-interactive='true']"));
    const viewportWidth = Math.max(1, document.documentElement.clientWidth || window.innerWidth || 1);
    const documentHeight = Math.max(viewportWidth, document.documentElement.scrollHeight || document.body.scrollHeight || 1);
    const xBucket = Math.max(0, Math.min(99, Math.floor(event.clientX / viewportWidth * 100)));
    const yBucket = Math.max(0, Math.min(99, Math.floor((window.scrollY + event.clientY) / documentHeight * 100)));
    const repetitionKey = `${targetKey}|${Math.floor(xBucket / 4)}|${Math.floor(yBucket / 4)}`;
    const now = Date.now();
    const repeated = uxLastPointer?.key === repetitionKey && now - uxLastPointer.at <= 900 ? uxLastPointer.count + 1 : 1;
    uxLastPointer = { key: repetitionKey, at: now, count: repeated };
    const interaction = repeated >= 3 ? "rage_tap" : interactive ? event.pointerType === "touch" ? "tap" : "click" : "dead_tap";
    const key = `${targetKey}|${xBucket}|${yBucket}|${interaction}`;
    const existing = uxPointCounts.get(key);
    if (existing) existing.count = Math.min(100, existing.count + 1);
    else uxPointCounts.set(key, { target_key: targetKey, x_bucket: xBucket, y_bucket: yBucket, interaction, count: 1 });
  }
  function observeUxSections() {
    uxSectionObserver?.disconnect();
    uxSectionObserver = new IntersectionObserver((entries) => {
      const now = Date.now();
      for (const entry of entries) {
        const key = stableMapKey(entry.target);
        const existing = uxSections.get(key) ?? {
          section_key: key,
          visible_ms: 0,
          max_visible_percent: 0,
          reached: false,
          top_bucket: 0,
          height_bucket: 0,
          visible_started_at: 0
        };
        const documentHeight = Math.max(1, document.documentElement.scrollHeight || document.body.scrollHeight || 1);
        const sectionTop = Math.max(0, window.scrollY + entry.boundingClientRect.top);
        existing.top_bucket = Math.max(0, Math.min(99, Math.floor(sectionTop / documentHeight * 100)));
        existing.height_bucket = Math.max(1, Math.min(100, Math.ceil(entry.boundingClientRect.height / documentHeight * 100)));
        const visible = entry.isIntersecting && document.visibilityState === "visible";
        if (visible) existing.max_visible_percent = Math.max(existing.max_visible_percent, Math.round(entry.intersectionRatio * 100));
        existing.reached || (existing.reached = visible);
        if (visible && !existing.visible_started_at) existing.visible_started_at = now;
        if (!visible && existing.visible_started_at) {
          existing.visible_ms = Math.min(18e5, existing.visible_ms + now - existing.visible_started_at);
          existing.visible_started_at = 0;
        }
        uxSections.set(key, existing);
      }
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    for (const section of document.querySelectorAll("[data-mc-map-section]")) {
      uxSectionObserver.observe(section);
    }
  }
  function flushUxObservation(preferBeacon = false) {
    if (!firstPartyAllowed() || !pageViewId || !uxStartedAt) return;
    const now = Date.now();
    const sections = Array.from(uxSections.values()).map((section) => ({
      section_key: section.section_key,
      visible_ms: Math.min(18e5, section.visible_ms + (section.visible_started_at ? now - section.visible_started_at : 0)),
      max_visible_percent: section.max_visible_percent,
      reached: section.reached,
      top_bucket: section.top_bucket,
      height_bucket: section.height_bucket
    }));
    if (!uxPointCounts.size && !sections.some((section) => section.reached)) return;
    const activeSeconds = Math.min(1800, Math.round((activeMilliseconds + (activeStartedAt ? now - activeStartedAt : 0)) / 1e3));
    const checkpoint = uxCheckpointChanged(
      uxLastCheckpoint,
      activeSeconds,
      maxScrollPercent,
      sections.filter((section) => section.reached).map((section) => section.section_key),
      uxPointCounts.size > 0
    );
    if (!checkpoint.changed) return;
    uxLastCheckpoint = checkpoint.signature;
    sendObservability("ux", {
      batch_id: randomValue(),
      page_view_id: pageViewId,
      page_path: location.pathname,
      experience_context: experienceContext(),
      viewport_width: Math.max(240, Math.round(window.innerWidth)),
      viewport_height: Math.max(240, Math.round(window.innerHeight)),
      document_height: Math.max(240, Math.round(document.documentElement.scrollHeight)),
      points: Array.from(uxPointCounts.values()).slice(0, 128),
      sections: sections.slice(0, 64),
      max_scroll_percent: maxScrollPercent,
      active_seconds: activeSeconds,
      mask_policy_version: UX_MASK_POLICY_VERSION,
      observed_at: (/* @__PURE__ */ new Date()).toISOString(),
      consent_snapshot: consentSnapshot()
    }, preferBeacon);
    uxPointCounts.clear();
    for (const section of uxSections.values()) {
      section.visible_ms = 0;
      if (section.visible_started_at) section.visible_started_at = now;
    }
  }
  function pauseUxVisibility() {
    const now = Date.now();
    for (const section of uxSections.values()) {
      if (section.visible_started_at) {
        section.visible_ms = Math.min(18e5, section.visible_ms + now - section.visible_started_at);
        section.visible_started_at = 0;
      }
    }
  }
  function scheduleUxFlush(delay = UX_FLUSH_MS) {
    if (uxFlushTimer) clearTimeout(uxFlushTimer);
    uxFlushTimer = setTimeout(() => {
      if (document.visibilityState === "visible") flushUxObservation();
      scheduleUxFlush();
    }, delay);
  }
  function startUxObservability() {
    if (!firstPartyAllowed() || uxStartedAt) return;
    uxStartedAt = Date.now();
    uxLastCheckpoint = "";
    prepareMapTargets();
    observeUxSections();
    document.addEventListener("pointerup", recordUxPointer, { passive: true });
    scheduleUxFlush(UX_FIRST_FLUSH_MS);
  }
  function stopUxObservability() {
    if (uxStartedAt) flushUxObservation(true);
    document.removeEventListener("pointerup", recordUxPointer);
    uxSectionObserver?.disconnect();
    uxSectionObserver = null;
    if (uxFlushTimer) clearTimeout(uxFlushTimer);
    uxFlushTimer = null;
    uxStartedAt = 0;
    uxPointCounts.clear();
    uxSections.clear();
  }
  function replayEligible() {
    if (!firstPartyAllowed() || cfg().isInternal === true) return false;
    if (typeof CompressionStream !== "function") return false;
    if (/^\/(checkouts?|account|cart|search)(?:\/|$)/i.test(location.pathname)) return false;
    return true;
  }
  async function replayFetch(path, body, keepalive = false) {
    const url = observabilityUrl(path);
    if (!url.startsWith("https://")) return null;
    const jsonBody = JSON.stringify(body);
    let requestBody = jsonBody;
    let transportBytes = new TextEncoder().encode(jsonBody).byteLength;
    const headers = { "content-type": "text/plain;charset=UTF-8" };
    if (path === "replay/chunk") {
      try {
        const source = new Response(new TextEncoder().encode(jsonBody)).body;
        if (!source) return null;
        const compressed = await new Response(
          source.pipeThrough(new CompressionStream("gzip"))
        ).arrayBuffer();
        if (!compressed.byteLength || compressed.byteLength > REPLAY_MAX_TRANSPORT_BYTES) return null;
        requestBody = compressed;
        transportBytes = compressed.byteLength;
        headers["content-type"] = "application/octet-stream";
        headers["x-mc-content-encoding"] = "gzip";
      } catch {
        return null;
      }
    }
    const useKeepalive = keepalive && transportBytes <= 60 * 1024;
    return fetch(url, {
      method: "POST",
      credentials: "omit",
      headers,
      body: requestBody,
      keepalive: useKeepalive,
      signal: useKeepalive ? void 0 : AbortSignal.timeout(1e4)
    }).catch(() => null);
  }
  function loadReplayRecorder() {
    if (window.MilouReplay?.start) return Promise.resolve(true);
    if (replayLoader) return replayLoader;
    const src = replayScriptSource(cfg().replayScriptUrl, location.href);
    if (!src) return Promise.resolve(false);
    replayLoader = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.mcReplayLoader = "true";
      script.addEventListener("load", () => resolve(Boolean(window.MilouReplay?.start)), { once: true });
      script.addEventListener("error", () => resolve(false), { once: true });
      document.head.appendChild(script);
    });
    return replayLoader;
  }
  function scheduleReplayFlush() {
    if (replayFlushTimer) clearTimeout(replayFlushTimer);
    replayFlushTimer = setTimeout(() => {
      queueReplayChunkUpload();
      scheduleReplayFlush();
    }, REPLAY_FLUSH_MS);
  }
  function queueReplayChunkUpload(keepalive = false) {
    if (!replayEvents.length || !replayId || !replayUploadToken) return;
    if (replayChunkIndex >= REPLAY_MAX_CHUNKS) {
      replayEvents = [];
      replayEventsBytes = 0;
      return;
    }
    const events = replayEvents;
    const receipt = replayReceipt;
    const chunkIndex = replayChunkIndex;
    const body = {
      upload_token: replayUploadToken,
      replay_id: replayId,
      chunk_index: chunkIndex,
      events,
      contains_input_values: false,
      contains_console_or_network_bodies: false,
      consent_snapshot: consentSnapshot()
    };
    const storedBytes = new TextEncoder().encode(JSON.stringify({
      schema_version: 1,
      replay_id: replayId,
      chunk_index: chunkIndex,
      events
    })).byteLength;
    replayEvents = [];
    replayEventsBytes = 0;
    replayChunkIndex += 1;
    replayByteCount += storedBytes;
    replayUploadChain = replayUploadChain.then(async () => {
      if (receipt.failed) return;
      const uploaded = await retryReplayChunk(
        () => replayFetch("replay/chunk", body, keepalive),
        firstPartyAllowed,
        (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      );
      if (!uploaded) {
        receipt.failed = true;
        return;
      }
      if (chunkIndex === receipt.chunks) {
        receipt.chunks++;
        receipt.bytes += storedBytes;
        const timestamp = Number(events.at(-1)?.timestamp);
        receipt.endedAt = new Date(Number.isFinite(timestamp) ? timestamp : Date.now()).toISOString();
      }
    }).catch(() => void 0);
  }
  async function startSessionReplay() {
    if (!replayEligible() || replayStop || replayId) return;
    replayId = randomValue();
    replayStartedAt = (/* @__PURE__ */ new Date()).toISOString();
    replayReceipt = { chunks: 0, bytes: 0, endedAt: replayStartedAt, failed: false };
    const response = await replayFetch("replay/start", {
      replay_id: replayId,
      page_view_id: pageViewId,
      page_path: location.pathname,
      experience_context: experienceContext(),
      mask_policy_version: REPLAY_MASK_POLICY_VERSION,
      recorder_version: REPLAY_RECORDER_VERSION,
      started_at: replayStartedAt,
      consent_snapshot: consentSnapshot()
    });
    if (!response?.ok || !firstPartyAllowed()) {
      replayId = "";
      replayStartedAt = "";
      return;
    }
    const body = await response.json();
    if (typeof body.upload_token !== "string") {
      replayId = "";
      replayStartedAt = "";
      return;
    }
    replayUploadToken = body.upload_token;
    if (!await loadReplayRecorder() || !firstPartyAllowed()) {
      replayId = "";
      replayUploadToken = "";
      replayStartedAt = "";
      return;
    }
    replayStop = window.MilouReplay?.start({
      emit(event) {
        if (!firstPartyAllowed()) return;
        const bytes = new TextEncoder().encode(JSON.stringify(event)).byteLength;
        if (bytes > REPLAY_MAX_EVENT_BYTES) {
          stopSessionReplay("failed");
          return;
        }
        if (replayChunkIndex >= REPLAY_MAX_CHUNKS || replayByteCount + replayEventsBytes + bytes > REPLAY_CLIENT_BYTE_LIMIT) {
          stopSessionReplay(replayChunkIndex > 0 ? "complete" : "failed");
          return;
        }
        if (replayEvents.length && replayEventsBytes + bytes > REPLAY_CHUNK_TARGET_BYTES) {
          queueReplayChunkUpload();
        }
        if (replayChunkIndex >= REPLAY_MAX_CHUNKS) {
          stopSessionReplay("complete");
          return;
        }
        replayEvents.push(event);
        replayEventsBytes += bytes;
        if (replayEventsBytes >= REPLAY_CHUNK_TARGET_BYTES) queueReplayChunkUpload();
      }
    });
    scheduleReplayFlush();
  }
  function stopSessionReplay(status, keepalive = false) {
    replayStop?.();
    replayStop = void 0;
    if (replayFlushTimer) clearTimeout(replayFlushTimer);
    replayFlushTimer = null;
    if (!replayId || !replayUploadToken) return;
    const acknowledgedExit = keepalive && status === "complete" && replayReceipt.chunks > 0;
    if (!acknowledgedExit) queueReplayChunkUpload(keepalive);
    const completion = {
      upload_token: replayUploadToken,
      replay_id: replayId,
      chunk_count: acknowledgedExit ? replayReceipt.chunks : replayChunkIndex,
      byte_count: acknowledgedExit ? replayReceipt.bytes : replayByteCount,
      ended_at: acknowledgedExit ? replayReceipt.endedAt : (/* @__PURE__ */ new Date()).toISOString(),
      status,
      consent_snapshot: consentSnapshot()
    };
    if (acknowledgedExit) {
      const url = observabilityUrl("replay/complete");
      let queued = false;
      try {
        queued = navigator.sendBeacon?.(url, new Blob([JSON.stringify(completion)], { type: "text/plain;charset=UTF-8" })) ?? false;
      } catch {
      }
      if (!queued) void replayFetch("replay/complete", completion, true);
    } else {
      const receipt = replayReceipt;
      replayUploadChain = replayUploadChain.then(async () => {
        if (status === "complete") {
          completion.chunk_count = receipt.chunks;
          completion.byte_count = receipt.bytes;
          completion.ended_at = receipt.endedAt;
          if (!receipt.chunks) completion.status = "failed";
        }
        await replayFetch("replay/complete", completion, keepalive);
      }).catch(() => void 0);
    }
    replayId = "";
    replayUploadToken = "";
    replayChunkIndex = 0;
    replayByteCount = 0;
    replayStartedAt = "";
    replayEvents = [];
    replayEventsBytes = 0;
  }
  function abortSessionReplay() {
    replayStop?.();
    replayStop = void 0;
    if (replayFlushTimer) clearTimeout(replayFlushTimer);
    replayFlushTimer = null;
    replayId = "";
    replayUploadToken = "";
    replayChunkIndex = 0;
    replayByteCount = 0;
    replayStartedAt = "";
    replayEvents = [];
    replayEventsBytes = 0;
  }
  function anonymousConsentContext(id, occurredAt, consent) {
    return {
      event_id: id,
      source: "storefront_browser",
      occurred_at: occurredAt,
      surface: "storefront_page",
      page_path: location.pathname,
      page_type: cfg().pageType ?? "unknown",
      is_internal: false,
      is_verified_bot: false,
      consent,
      attribution: {}
    };
  }
  function sendAnonymousConsentRecord(path, body) {
    const base = (cfg().ingressUrl ?? "").replace(/\/$/, "");
    const url = base ? `${base}/analytics/v1/${path}` : "";
    if (!url.startsWith("https://")) return;
    void fetch(url, {
      method: "POST",
      credentials: "omit",
      keepalive: true,
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body)
    }).catch(() => void 0);
  }
  function consentBannerViewed(input) {
    const id = cleanString(input.exposure_id, 80);
    if (!id || duplicateWithin(`consent:banner:${id}`, 3e4)) return;
    const occurredAt = input.occurred_at ?? (/* @__PURE__ */ new Date()).toISOString();
    const event = createConsentBannerViewedEvent(
      anonymousConsentContext(id, occurredAt, {
        analytics: false,
        marketing: false,
        preferences: false,
        first_party: false,
        sale_of_data: false
      }),
      { policy_version: cleanString(input.policy_version, 40) ?? "3" },
      compatibility()
    );
    sendAnonymousConsentRecord("consent-exposure", {
      ...event,
      exposure_id: id,
      page_path: cleanString(input.page_path, 300) ?? location.pathname
    });
  }
  function consentChoiceSaved(input) {
    const id = cleanString(input.decision_id, 80);
    if (!id || duplicateWithin(`consent:choice:${id}:${input.decision_source}`, 5e3)) return;
    const occurredAt = input.occurred_at ?? (/* @__PURE__ */ new Date()).toISOString();
    const snapshot = {
      analytics: input.analytics === true,
      marketing: input.marketing === true,
      preferences: input.preferences === true,
      first_party: input.first_party === true,
      sale_of_data: input.sale_of_data === true,
      consent_version: Number(input.policy_version) || 3,
      decision_id: id,
      decided_at: occurredAt
    };
    const event = createConsentChoiceSavedEvent(
      anonymousConsentContext(id, occurredAt, snapshot),
      {
        decision_source: input.decision_source,
        analytics: snapshot.analytics,
        marketing: snapshot.marketing,
        preferences: snapshot.preferences,
        first_party: snapshot.first_party
      },
      compatibility()
    );
    sendAnonymousConsentRecord("consent", {
      ...event,
      decision_id: id,
      decision_source: input.decision_source,
      analytics: snapshot.analytics,
      marketing: snapshot.marketing,
      first_party: snapshot.first_party,
      preferences: snapshot.preferences,
      sale_of_data: snapshot.sale_of_data,
      gpc: input.gpc === true,
      dnt: input.dnt === true,
      consent_version: snapshot.consent_version,
      page_path: cleanString(input.page_path, 300) ?? location.pathname
    });
  }
  function consentChoiceReset(input) {
    const id = cleanString(input.decision_id, 80);
    if (!id || duplicateWithin(`consent:reset:${id}`, 5e3)) return;
    const occurredAt = input.occurred_at ?? (/* @__PURE__ */ new Date()).toISOString();
    const snapshot = {
      analytics: false,
      marketing: false,
      preferences: false,
      first_party: false,
      sale_of_data: false,
      consent_version: Number(input.policy_version) || 3,
      decision_id: id,
      decided_at: occurredAt
    };
    const event = createConsentChoiceResetEvent(
      anonymousConsentContext(id, occurredAt, snapshot),
      { policy_version: cleanString(input.policy_version, 40) ?? "3" },
      compatibility()
    );
    sendAnonymousConsentRecord("consent", {
      ...event,
      decision_id: id,
      decision_source: "reset",
      analytics: false,
      marketing: false,
      first_party: false,
      preferences: false,
      sale_of_data: false,
      gpc: input.gpc === true,
      dnt: input.dnt === true,
      consent_version: snapshot.consent_version,
      page_path: cleanString(input.page_path, 300) ?? location.pathname
    });
  }
  function attachListeners() {
    if (listenersAttached) return;
    listenersAttached = true;
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("click", onClick);
    document.addEventListener("change", onChange);
    document.addEventListener("submit", onSubmit, { capture: true });
    document.addEventListener("mc:welcome-popup-viewed", onWelcomePopupViewed);
    document.addEventListener("mc:welcome-popup-closed", onWelcomePopupClosed);
    document.addEventListener("mc:product-gallery-navigated", onProductGalleryNavigated);
    document.addEventListener("mc:dog-size-selected", onDogSizeSelected);
    document.addEventListener("mc:package-selection-toggled", (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const state = event.detail?.state;
      const productHandle = productHandleForElement(target);
      if (!productHandle || state !== "opened" && state !== "closed") return;
      queueEvent(createProductDetailToggledEvent(context(surfaceForElement(target)), {
        product_handle: productHandle,
        detail_key: "package_selection",
        detail_title: "Paketwahl",
        detail_position: 1,
        state
      }, compatibility()));
      if (state === "opened") requestAnimationFrame(() => {
        const button = target?.querySelector("[data-mc-atc]");
        if (!button || viewedProductCtas.has(button) || document.visibilityState !== "visible") return;
        const rect = button.getBoundingClientRect();
        const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(0, rect.top));
        const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(0, rect.left));
        if (rect.width <= 0 || rect.height <= 0 || visibleWidth * visibleHeight / (rect.width * rect.height) < 0.5) return;
        const identity = productIdentity(button);
        if (!identity.productHandle) return;
        viewedProductCtas.add(button);
        queueEvent(createProductCtaViewedEvent(context(surfaceForElement(button)), {
          product_handle: identity.productHandle,
          variant_id: identity.variantId,
          cta_type: "add_to_cart",
          cta_surface: "primary"
        }, compatibility()));
        flush();
      });
      flush();
    });
    document.addEventListener("shopify:section:load", () => {
      initializeProductVisibilityTracking();
      initializeProductDecisionProofTracking();
      initializeProductDetailTracking();
      prepareMapTargets();
      observeUxSections();
    });
    document.addEventListener("theme:cart-drawer:open", () => {
      void emitCartView("cart_drawer");
    });
    document.addEventListener("cart:open", () => {
      void emitCartView("cart_drawer");
    });
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        pauseProductDecisionProofVisibility();
        updateActiveTime();
        pauseUxVisibility();
        flushUxObservation(true);
        finalizeEngagement();
        finalizeWebVitals();
        flush();
      } else if (trackingActive && !activeStartedAt) {
        activeStartedAt = Date.now();
        resumeProductDecisionProofVisibility();
        observeUxSections();
        ownedDelivery.resume();
      }
    });
    window.addEventListener("online", () => ownedDelivery.resume());
    window.addEventListener("pagehide", () => {
      stopSessionReplay("complete", true);
      flushUxObservation(true);
      finalizeEngagement();
      finalizeWebVitals();
      flush();
    });
    interceptCartFetch();
    initializeProductVisibilityTracking();
    initializeProductDetailTracking();
    startUxObservability();
    void startSessionReplay();
  }
  function clearFirstPartyIdentity() {
    try {
      for (const key of LEGACY_FIRST_PARTY_STORAGE_KEYS) localStorage.removeItem(key);
      sessionStorage.removeItem(CART_ATTR_SYNC_KEY);
    } catch {
    }
  }
  function stopTracker() {
    if (firstPartyAllowed()) stopSessionReplay("discarded", true);
    else abortSessionReplay();
    stopUxObservability();
    resetProductDecisionProofTracking();
    trackingActive = false;
    eventQueue = [];
    ownedDelivery.clear();
    pageViewId = "";
    pageStartAt = 0;
    activeStartedAt = 0;
    activeMilliseconds = 0;
    engagementRecorded = false;
    vitalsFinalized = false;
    clearFirstPartyIdentity();
  }
  function initTracker() {
    if (typeof window === "undefined" || !firstPartyAllowed() || trackingActive) return;
    trackingActive = true;
    clearFirstPartyIdentity();
    captureAttribution();
    trackPage();
    trackUrlBoundExperimentExposure();
    void loadFirstPartyExperimentAssignments();
    trackNewsletterOutcomes();
    attachListeners();
    initializeProductDecisionProofTracking();
    void syncCartAttributes();
    startUxObservability();
    void startSessionReplay();
    if (analyticsAllowed()) {
      window.setTimeout(() => void syncCartAttributes(true), 3e3);
    }
  }
  if (typeof window !== "undefined") {
    currentTouch = attributionTouchFromUrl(new URL(location.href), (/* @__PURE__ */ new Date()).toISOString(), referrerHost());
    window.MilouAnalytics = {
      track,
      flush,
      getAttribution,
      getCartAttributes,
      productRecommendationStarted,
      productRecommendationStepCompleted,
      productRecommendationCompleted,
      consentBannerViewed,
      consentChoiceSaved,
      consentChoiceReset,
      experimentVariantViewed
    };
    document.addEventListener("mc:consentchange", (event) => {
      const categories = event.detail?.categories;
      const lanes = resolveMeasurementLanes(categories ?? consentSnapshot());
      if (lanes.observe) {
        if (!lanes.first_party) clearFirstPartyIdentity();
        if (!lanes.attribution_storage) {
          try {
            sessionStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
          } catch {
          }
          storedAttribution = void 0;
        }
        captureAttribution();
        initTracker();
        if (lanes.first_party) startUxObservability();
        else stopUxObservability();
        if (lanes.first_party) void startSessionReplay();
        else abortSessionReplay();
        void syncCartAttributes(true);
      } else {
        stopTracker();
        try {
          sessionStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
        } catch {
        }
        storedAttribution = void 0;
        void syncCartAttributes(true);
      }
    });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initTracker);
    else initTracker();
  }
  return __toCommonJS(index_exports);
})();
